/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://openchair.threadcommunication.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__(6);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _ravenJs = __webpack_require__(3);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _v = __webpack_require__(35);

var _v2 = _interopRequireDefault(_v);

var _openchair = __webpack_require__(38);

var _openchair2 = _interopRequireDefault(_openchair);

var _data = __webpack_require__(40);

var _data2 = _interopRequireDefault(_data);

var _views = __webpack_require__(41);

var _views2 = _interopRequireDefault(_views);

var _dataHelpers = __webpack_require__(18);

var _domHelpers = __webpack_require__(1);

var _analytics = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetCtrl = {
  init: function init() {
    var _this = this;

    // TODO: decide on which elements on the page are customizable and add appropriate classes throughout
    (0, _domHelpers.fontLoader)();
    var widgetDiv = document.getElementById('openchair-widget');
    widgetDiv.className = _openchair2.default.openchairRoot;
    var token = widgetDiv.dataset.token;

    _data2.default.calendarStart = (0, _momentTimezone2.default)();
    _data2.default.calendarEnd = (0, _momentTimezone2.default)().add(13, 'weeks').endOf('week');
    var end = _data2.default.calendarStart.clone().endOf('week').add(2, 'weeks');
    _data2.default.clientUiid = (0, _v2.default)();

    return (0, _dataHelpers.getBookings)(_data2.default.calendarStart, end, token).then(function (res) {
      if (!('practice_name' in res) || !('locations' in res) || !res.locations.length) {
        return Promise.reject(new Error('Make sure that a practice has a name and at least one location'));
      }
      _data2.default.practiceName = res.practice_name;
      _data2.default.bookings = res.bookings;
      _data2.default.locations = res.locations;
      _data2.default.timezone = res.locations[0].timezone;
      _data2.default.cloud9_practice = res.cloud9_practice;
      _data2.default.currentLocation = _data2.default.locations[0];
      _data2.default.currentLocation.bookings = _this.getBookingsForLocation(_data2.default.currentLocation);
      _data2.default.loadedUntil = end;
      if ('orthoconfirm' in widgetDiv.dataset) {
        _data2.default.orthoConfirm = widgetDiv.dataset.orthoconfirm;
      }
      _views2.default.init(widgetDiv);
      // call onLoad tracker
      (0, _analytics.onButtonLoad)();
      return Promise.resolve();
    }).catch(function (err) {
      console.log(err);
      _ravenJs2.default.captureException(err);
    });
  },
  loadNextPage: function loadNextPage() {
    var _this2 = this;

    var start = _data2.default.loadedUntil.clone().add(1, 'days');
    var end = _data2.default.loadedUntil.clone().add(2, 'weeks');
    return (0, _dataHelpers.getBookings)(start, end).then(function (res) {
      _data2.default.bookings = _data2.default.bookings.concat(res.bookings);
      _data2.default.currentLocation.bookings = _this2.getBookingsForLocation(_data2.default.currentLocation);
      _data2.default.loadedUntil = end;
    }).catch(function (err) {
      // this.showError(); should we be showing this error to the user??
      _ravenJs2.default.captureException(err);
    });
  },
  cloud9Practice: function cloud9Practice() {
    return _data2.default.cloud9_practice;
  },
  getExtraFormInfo: function getExtraFormInfo() {
    return _data2.default.orthoConfirm;
  },
  getTz: function getTz() {
    return _data2.default.timezone || _momentTimezone2.default.tz.guess();
  },
  getLoadStatus: function getLoadStatus() {
    return _data2.default.loadedUntil.diff(_data2.default.calendarEnd, 'weeks');
  },
  getAllBookings: function getAllBookings() {
    return _data2.default.bookings;
  },
  getBookingsForLocation: function getBookingsForLocation() {
    var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _data2.default.currentLocation;

    return _data2.default.bookings.filter(function (booking) {
      return booking.location_id === location.id;
    });
  },
  getBookingsForDay: function getBookingsForDay(day, bookings) {
    var bookingsForPeriod = [];
    for (var i = 0; i < bookings.length; i++) {
      if (day.isSame(bookings[i].start_datetime, 'day')) {
        bookingsForPeriod.push(bookings[i]);
      } else if (day.isBefore(bookings[i].start_datetime, 'day')) {
        break;
      }
    }
    return bookingsForPeriod;
  },
  getNumberBookingsAvailable: function getNumberBookingsAvailable() {
    var weekRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _momentTimezone2.default)().tz(this.getTz());
    var bookings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _data2.default.bookings;

    var bookingsForPeriod = [];
    for (var i = 0; i < bookings.length; i++) {
      if (weekRef.isSame(bookings[i].start_datetime, 'week')) {
        bookingsForPeriod.push(bookings[i]);
      } else if (weekRef.isBefore(bookings[i].start_datetime, 'week')) {
        break;
      }
    }
    return bookingsForPeriod;
  },
  getNumberBookingsAvailableForLocations: function getNumberBookingsAvailableForLocations() {
    var weekRef = _data2.default.currentDay || undefined;
    var hotBookings = this.getNumberBookingsAvailable(weekRef);
    var hotBookingsPerLocation = {};
    for (var i = 0; i < hotBookings.length; i++) {
      if (hotBookingsPerLocation[hotBookings[i].location_id] === undefined) {
        hotBookingsPerLocation[hotBookings[i].location_id] = 0;
      }
      hotBookingsPerLocation[hotBookings[i].location_id]++;
    }
    return hotBookingsPerLocation;
  },
  findNextAvailableAppointment: function findNextAvailableAppointment(startdate) {
    var bookings = this.getCurrentLocation().bookings;
    for (var i = 0; i < bookings.length; i++) {
      if (startdate.isSameOrBefore(bookings[i].start_datetime, 'day')) {
        return _momentTimezone2.default.tz(bookings[i].start_datetime, this.getTz());
      }
    }
    return null;
  },
  refreshBookings: function refreshBookings() {
    var end = _data2.default.calendarStart.clone().endOf('week').add(2, 'weeks');
    return (0, _dataHelpers.getBookings)(_data2.default.calendarStart, end).then(function (res) {
      _data2.default.clientUiid = (0, _v2.default)();
      _data2.default.bookings = res.bookings;
      _data2.default.currentLocation.bookings = _data2.default.bookings.filter(function (booking) {
        return booking.location_id === _data2.default.currentLocation.id;
      });
      _data2.default.loadedUntil = end;
    }).catch(function (err) {
      _ravenJs2.default.captureException(err);
    });
  },
  getOrthoConfirm: function getOrthoConfirm() {
    return _data2.default.orthoConfirm;
  },
  getPracticeName: function getPracticeName() {
    return _data2.default.practiceName;
  },
  getLocations: function getLocations() {
    return _data2.default.locations;
  },
  getCurrentLocation: function getCurrentLocation() {
    return _data2.default.currentLocation;
  },
  setCurrentLocation: function setCurrentLocation(location) {
    _data2.default.currentLocation = location;
    _data2.default.currentLocation.bookings = _data2.default.bookings.filter(function (booking) {
      return booking.location_id === _data2.default.currentLocation.id;
    });
  },
  holdBooking: function holdBooking(booking) {
    var _this3 = this;

    return (0, _dataHelpers.putBooking)(booking.id, 'pending').then(function () {
      _this3.setAppointmentInfo(booking);
    }).catch(function (err) {
      _this3.showError();
      _ravenJs2.default.captureException(err);
    });
  },
  confirmBooking: function confirmBooking() {
    var booking = this.getAppointmentInfo();
    var patient = this.getPatientInfo();
    var body = JSON.stringify({
      patient: {
        first_name: patient['patient first name'],
        last_name: patient['patient last name'],
        guardian_name: patient['guardian name'] || null,
        zip_code: patient['zip code'] || null,
        phone: patient.phone,
        email: patient.email,
        message: patient.message || null,
        location_id: booking.location_id,
        client_uuid: _data2.default.clientUiid
      },
      appointment: {
        appointment_datetime: booking.start_datetime
      },
      booking: {
        id: booking.id
      }
    });
    return (0, _dataHelpers.postAppointment)(body);
  },
  setAppointmentInfo: function setAppointmentInfo(booking) {
    _data2.default.appointmentInfo = booking;
  },
  getAppointmentInfo: function getAppointmentInfo() {
    return _data2.default.appointmentInfo;
  },
  setLatLngForLocations: function setLatLngForLocations(latLngs) {
    latLngs.forEach(function (v, i) {
      _data2.default.locations[i].latLng = v;
    });
  },
  getCurrentDay: function getCurrentDay() {
    return _data2.default.currentDay;
  },
  setCurrentDay: function setCurrentDay(day) {
    _data2.default.currentDay = day;
  },
  getPatientInfo: function getPatientInfo() {
    return _data2.default.patientInfo;
  },
  setPatientInfo: function setPatientInfo(patient) {
    _data2.default.patientInfo = patient;
  },
  showError: function showError() {
    var errorText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Sorry, something went wrong. \nPlease try again.';

    _views2.default.handleError(errorText);
  }
};

// have to use module.exports to require this file
module.exports.widgetCtrl = widgetCtrl;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAttributes = setAttributes;
exports.createEl = createEl;
exports.createBtn = createBtn;
exports.createScript = createScript;
exports.getFormData = getFormData;
exports.toggle = toggle;
exports.removeClass = removeClass;
exports.scrollTo = scrollTo;
exports.fontLoader = fontLoader;
exports.scriptLoader = scriptLoader;
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (key) {
    element.setAttribute(key, attributes[key]);
  });
}

function createEl(tag, classes, textNode, attributes) {
  var element = document.createElement(tag);
  if (classes) {
    element.className = classes;
  }
  if (textNode) {
    element.textContent = textNode;
  }
  if (attributes) {
    setAttributes(element, attributes);
  }
  return element;
}

function createBtn(classes, title) {
  return createEl('button', classes, title, { type: 'button' });
}

function createScript(src) {
  var element = document.createElement('script');
  var attributes = {
    src: src,
    async: true,
    defer: true
  };
  setAttributes(element, attributes);
  return element;
}

function getFormData(form) {
  if ('elements' in form) {
    var data = {};
    Array.from(form.elements).forEach(function (el) {
      if (el.id && el.value) {
        var key = el.id.split('-').slice(1).join(' ');
        data[key] = el.value;
      }
    });
    return data;
  }
  return null;
}

function toggle(hide, show) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'flex';

  hide.style.display = 'none';
  show.style.display = value;
}
function removeClass(elem, className) {
  var classList = elem.className.split(' ');
  elem.className = classList.filter(function (name) {
    return name !== className;
  }).join(' ');
}

function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  var difference = to - element.scrollLeft;
  var perTick = difference / duration * 10;

  setTimeout(function () {
    element.scrollLeft += perTick;
    if (element.scrollLeft === to) return;
    scrollTo(element, to, duration - 2);
  }, 0);
}

function fontLoader() {
  var entry = document.getElementsByTagName('script')[0];
  entry.parentNode.insertBefore(createEl('link', '', '', {
    href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
    rel: 'stylesheet'
  }), entry);
  entry.parentNode.insertBefore(createEl('link', '', '', {
    href: 'https://fonts.googleapis.com/css?family=Lato:300,400,700,900',
    rel: 'stylesheet'
  }), entry);
}

function scriptLoader(src) {
  var entry = document.getElementsByTagName('script')[0];
  return entry.parentNode.insertBefore(createScript(src), entry);
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".openchair_openchair__material-icons--whnz9{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\"}.openchair_openchair__openchairRoot--1SkEB{-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;font-family:Lato,sans-serif}", ""]);

// exports
exports.locals = {
	"material-icons": "openchair_openchair__material-icons--whnz9",
	"openchairRoot": "openchair_openchair__openchairRoot--1SkEB"
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/



var RavenConstructor = __webpack_require__(26);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function () {
	_window.Raven = _Raven;
	return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(39);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(31);
moment.tz.load(__webpack_require__(34));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onMapClick = exports.onRequestSubmission = exports.onFormSubmissionClick = exports.onAppointmentClick = exports.onButtonClick = exports.onButtonLoad = undefined;

var _dataHelpers = __webpack_require__(18);

// on button load
var onButtonLoad = exports.onButtonLoad = function onButtonLoad() {
  var body = JSON.stringify({
    label: 'openchair',
    event_type: 'load',
    description: 'mainButton'
  });

  (0, _dataHelpers.postEvent)(body);
};

// on button hover
// export const onButtonHover = () => {
//   const body = JSON.stringify({
//     label: 'openchair',
//     event_type: 'hover',
//     description: 'mainButton',
//   });
// 
//   postEvent(body);
// };

// on button click
var onButtonClick = exports.onButtonClick = function onButtonClick() {
  var body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'mainButton'
  });

  (0, _dataHelpers.postEvent)(body);
};

// on appointment click
var onAppointmentClick = exports.onAppointmentClick = function onAppointmentClick() {
  var body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'appointment'
  });

  (0, _dataHelpers.postEvent)(body);
};

// "Review Details" button on form submit
var onFormSubmissionClick = exports.onFormSubmissionClick = function onFormSubmissionClick() {
  var body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'formSubmission'
  });

  (0, _dataHelpers.postEvent)(body);
};

// "Request Appointment" button (final submission)
var onRequestSubmission = exports.onRequestSubmission = function onRequestSubmission() {
  var body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'confirmBooking'
  });

  (0, _dataHelpers.postEvent)(body);
};

var onMapClick = exports.onMapClick = function onMapClick() {
  var body = JSON.stringify({
    label: 'openchair',
    event_type: 'click',
    description: 'mapMarker'
  });

  (0, _dataHelpers.postEvent)(body);
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findTimeText = undefined;

var _momentTimezone = __webpack_require__(6);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _hammerjs = __webpack_require__(47);

var _ravenJs = __webpack_require__(3);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _domHelpers = __webpack_require__(1);

var _setColors = __webpack_require__(11);

var _analytics = __webpack_require__(7);

var _widgetController = __webpack_require__(0);

var _widgetModal = __webpack_require__(10);

var _widgetModal2 = _interopRequireDefault(_widgetModal);

var _locations = __webpack_require__(19);

var _locations2 = _interopRequireDefault(_locations);

var _calendar = __webpack_require__(48);

var _calendar2 = _interopRequireDefault(_calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* global ga */

var findTimeText = exports.findTimeText = function findTimeText(automation, startDateTime) {
  var timeString = _momentTimezone2.default.tz(startDateTime, _widgetController.widgetCtrl.getTz()).format('h:mm A');
  if (!automation) return timeString;
  if (timeString === '9:30 AM') {
    return 'Late Morning';
  }
  if (timeString === '12:00 PM') {
    return 'Early Afternoon';
  }
  if (timeString === '2:30 PM') {
    return 'Late Afternoon';
  }
  return 'Early Morning';
};

var calendar = {
  init: function init() {
    this.calendarContainer = (0, _domHelpers.createEl)('div', _calendar2.default.calendar);
    this.initWeek();
    this.initTimes();
    this.timesInstruction = (0, _domHelpers.createEl)('div', _calendar2.default.timesInstruction);

    var dateTimeLabel = (0, _domHelpers.createEl)('span', _calendar2.default.dateTimeLabel);
    dateTimeLabel.textContent = 'choose date and time';
    // APPEND SPAN BEFORE weekContainer below
    this.calendarContainer.append(dateTimeLabel, this.weekContainer, this.timesInstruction, this.timesContainer, this.overlay);

    return this.calendarContainer;
  },
  initTimes: function initTimes() {
    this.timesContainer = (0, _domHelpers.createEl)('div', _calendar2.default.timesContainer);
    this.times = (0, _domHelpers.createEl)('div', _calendar2.default.times);
    // TODO: add up/down arrows and configure their scolling behavior
    // const timesArrow = createEl('div', styles.arrow, 'keyboard_arrow_down');
    this.timesContainer.append(this.times);
    this.overlay = (0, _domHelpers.createEl)('div', _calendar2.default.timesOverlay);
  },
  initWeek: function initWeek() {
    var _this = this;

    this.weekStart = (0, _momentTimezone2.default)().tz(_widgetController.widgetCtrl.getTz()).startOf('week');
    this.weekContainer = (0, _domHelpers.createEl)('div', _calendar2.default.weekContainer);
    this.week = (0, _domHelpers.createEl)('div', _calendar2.default.week);

    // create calendar days:
    var calendarDay = this.weekStart.clone();
    var bookings = _widgetController.widgetCtrl.getAllBookings();
    var lastAvailable = bookings.length ? _momentTimezone2.default.tz(bookings[bookings.length - 1].start_datetime, _widgetController.widgetCtrl.getTz()).endOf('week') : (0, _momentTimezone2.default)().tz(_widgetController.widgetCtrl.getTz()).endOf('week');

    while (calendarDay.isSameOrBefore(lastAvailable, 'day')) {
      var day = this.makeDay(calendarDay.clone());
      this.week.append(day);
      calendarDay.add(1, 'd');
    }

    var leftArrow = (0, _domHelpers.createEl)('div', _calendar2.default.arrow, 'keyboard_arrow_left');
    var rightArrow = (0, _domHelpers.createEl)('div', _calendar2.default.arrow, 'keyboard_arrow_right');
    this.weekContainer.append(leftArrow, this.week, rightArrow);

    // define arrow/swipe listeners
    this.toggleWeekArrows = function () {
      leftArrow.style.visibility = _this.weekIndex > 0 ? 'visible' : 'hidden';
      rightArrow.style.visibility = (_this.weekIndex + 1) * 7 === _this.week.childNodes.length ? 'hidden' : 'visible';
    };

    var scrollCalendar = function scrollCalendar(direction) {
      // Google Analytics:
      if (true) {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Calendar',
          eventAction: 'scroll'
        });
      }
      _this.removeActiveClass();
      var scrollLeft = _this.week.clientWidth * _this.weekIndex;
      if (direction === 'right' && (_this.weekIndex + 1) * 7 < _this.week.childNodes.length) {
        (0, _domHelpers.scrollTo)(_this.week, scrollLeft + _this.week.clientWidth, 200);
        _this.weekStart.add(1, 'week');
        _this.weekIndex++;
      } else if (direction === 'left' && _this.weekIndex > 0) {
        (0, _domHelpers.scrollTo)(_this.week, scrollLeft - _this.week.clientWidth, 200);
        _this.weekStart.subtract(1, 'week');
        _this.weekIndex--;
      }
      // 13 is the max number of weeks we are showing to the user
      // getLoadStatus returns a negatice number that indicates how many weeks left to load
      if (13 - _this.weekIndex + _widgetController.widgetCtrl.getLoadStatus() <= 2) {
        _this.loadMoreAppointments().then(function () {
          _this.findFirstAppointmentThisWeek();
          return _this.renderTimes();
        }).then(function () {
          _locations2.default.render();
          _this.toggleWeekArrows();
        }).catch(function (err) {
          _ravenJs2.default.captureException(err);
        });
      } else {
        _this.findFirstAppointmentThisWeek();
        _this.renderTimes().then(function () {
          _locations2.default.render();
          _this.toggleWeekArrows();
        }).catch(function (err) {
          _ravenJs2.default.captureException(err);
        });
      }
    };

    rightArrow.addEventListener('click', function () {
      scrollCalendar('right');
    });

    leftArrow.addEventListener('click', function () {
      scrollCalendar('left');
    });

    // for touch enabled devices:
    var touchableWeek = new _hammerjs.Manager(this.week, { recognizers: [[_hammerjs.Swipe]] });
    touchableWeek.on('swipeleft', function () {
      scrollCalendar('right');
    });
    touchableWeek.on('swiperight', function () {
      scrollCalendar('left');
    });
  },
  makeDay: function makeDay(date) {
    var _this2 = this;

    var day = (0, _domHelpers.createEl)('div', _calendar2.default.day);
    var dayOfWeek = (0, _domHelpers.createEl)('div', _calendar2.default.dayOfWeek, date.format('dd')[0]);
    var month = (0, _domHelpers.createEl)('div', _calendar2.default.month, date.format('MMM'));
    var dayOfMonth = (0, _domHelpers.createEl)('div', _calendar2.default.dayOfMonth);
    var innerDay = (0, _domHelpers.createEl)('div', _calendar2.default.dayOfMonthInner, date.format('D'), { name: 'openChairWidgetInnerDay' });
    dayOfMonth.append(innerDay);
    day.append(dayOfWeek, month, dayOfMonth);

    day.addEventListener('click', function () {
      // Google Analytics:
      if (true) {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Calendar',
          eventAction: 'daySelect'
        });
      }

      _this2.selectDay(day, date);
      _this2.renderTimes();
    });
    return day;
  },
  markAvailableDays: function markAvailableDays() {
    var days = Array.from(this.week.childNodes);
    var calendarDay = this.weekStart.clone().subtract(this.weekIndex, 'weeks');
    var bookings = _widgetController.widgetCtrl.getCurrentLocation().bookings;
    var i = 0;
    var j = 0;
    while (i < days.length) {
      if (j >= bookings.length || calendarDay.isBefore(bookings[j].start_datetime, 'day')) {
        days[i].className = _calendar2.default.day + '  ' + _calendar2.default.isUnavailable;
        calendarDay.add(1, 'day');
        i++;
      } else if (calendarDay.isSame(bookings[j].start_datetime, 'day')) {
        (0, _domHelpers.removeClass)(days[i], _calendar2.default.isUnavailable);
        i++;
        j++;
        calendarDay.add(1, 'day');
      } else {
        j++;
      }
    }
  },
  removeActiveClass: function removeActiveClass(clickedEl) {
    var lastActive = this.week.querySelector('.' + _calendar2.default.isActive);
    if (lastActive) {
      var lastActiveStyle = lastActive.childNodes[2].childNodes[0].style;
      (0, _domHelpers.removeClass)(lastActive, _calendar2.default.isActive);
      if (clickedEl !== lastActive) {
        lastActiveStyle.removeProperty('background');
        lastActiveStyle.removeProperty('color');
      }
    }
  },
  selectDay: function selectDay(dayElem, date) {
    var dayOfMonthInner = dayElem.childNodes[2].childNodes[0];

    (0, _setColors.setSecondaryColor)(dayOfMonthInner, _calendar2.default.dayOfMonthInner);

    this.removeActiveClass(dayElem);
    this.timesContainer.scrollTop = 0;
    if (dayElem && date) {
      dayElem.className += '  ' + _calendar2.default.isActive;
      _widgetController.widgetCtrl.setCurrentDay(date);
    } else {
      _widgetController.widgetCtrl.setCurrentDay(null);
    }
  },
  findFirstAppointmentThisWeek: function findFirstAppointmentThisWeek() {
    var calendarDay = this.weekStart.clone();
    for (var i = 0; i < 7; i++) {
      var dayElem = this.week.childNodes[this.weekIndex * 7 + calendarDay.day()];
      if (dayElem.className.split(' ').indexOf(_calendar2.default.isUnavailable) < 0) {
        this.selectDay(dayElem, calendarDay.clone());
        return;
      }
      calendarDay.add(1, 'days');
    }
    // select monday unless it's the first (current week) - in that case select today
    this.weekIndex > 0 ? this.selectDay(this.week.childNodes[this.weekIndex * 7], this.weekStart.clone()) : this.selectDay(this.week.childNodes[(0, _momentTimezone2.default)().day()], (0, _momentTimezone2.default)());
  },
  loadMoreAppointments: function loadMoreAppointments() {
    var _this3 = this;

    _widgetModal2.default.toggleSpinner();
    var bookings = _widgetController.widgetCtrl.getAllBookings();
    var lastRendered = bookings.length ? _momentTimezone2.default.tz(bookings[bookings.length - 1].start_datetime, _widgetController.widgetCtrl.getTz()).endOf('week').add(1, 'day') : (0, _momentTimezone2.default)().tz(_widgetController.widgetCtrl.getTz()).endOf('week').add(1, 'day');
    return _widgetController.widgetCtrl.loadNextPage().then(function () {
      bookings = _widgetController.widgetCtrl.getAllBookings();
      var lastAvailable = bookings.length ? _momentTimezone2.default.tz(bookings[bookings.length - 1].start_datetime, _widgetController.widgetCtrl.getTz()).endOf('week') : _momentTimezone2.default.tz(_widgetController.widgetCtrl.getTz()).endOf('week');

      while (lastRendered.isSameOrBefore(lastAvailable, 'day')) {
        var day = _this3.makeDay(lastRendered.clone());
        _this3.week.append(day);
        lastRendered.add(1, 'd');
      }
      _this3.markAvailableDays();
      _widgetModal2.default.toggleSpinner();
    }).catch(function (err) {
      _ravenJs2.default.captureException(err);
    });
  },
  renderOverlay: function renderOverlay(timeframe, nextAvailable) {
    var _this4 = this;

    var message = (0, _domHelpers.createEl)('p', _calendar2.default.overlayText);
    if (nextAvailable) {
      this.overlayLink = (0, _domHelpers.createEl)('span', _calendar2.default.nextAppointmentLink, '' + nextAvailable.format('ddd, MMM D'));
      message.textContent = 'Next available at this location: \n';
      message.append(this.overlayLink, (0, _domHelpers.createEl)('span', _calendar2.default.linkArrow, 'keyboard_arrow_right'));

      this.overlayLink.addEventListener('click', function (e) {
        e.preventDefault();
        var weekDiff = nextAvailable.diff(_this4.weekStart, 'weeks');
        _this4.weekStart.add(weekDiff, 'weeks');
        _this4.weekIndex += weekDiff;
        (0, _domHelpers.scrollTo)(_this4.week, _this4.week.clientWidth * _this4.weekIndex, 200);
        setTimeout(function () {
          _this4.selectDay(_this4.week.childNodes[nextAvailable.day() + _this4.weekIndex * 7], nextAvailable);
          _locations2.default.render();
          _this4.renderTimes().then(function () {
            _this4.toggleWeekArrows();
          });
        }, 200);
      });
    } else if (_widgetController.widgetCtrl.getLoadStatus() < 1) {
      return this.loadMoreAppointments().then(function () {
        return _this4.renderTimes();
      }).catch(function (err) {
        _ravenJs2.default.captureException(err);
      });
    } else {
      message.textContent = 'No future appoinments available\n for this location.';
    }
    // this.overlay.textContent = `No appointments available this ${timeframe}.`;
    this.overlay.innerHTML = '';
    this.overlay.append(message);

    (0, _domHelpers.toggle)(this.timesContainer, this.overlay);
  },
  renderTimes: function renderTimes() {
    var day = _widgetController.widgetCtrl.getCurrentDay();
    var location = _widgetController.widgetCtrl.getCurrentLocation();
    if (!day) {
      return Promise.resolve(this.renderOverlay('week', _widgetController.widgetCtrl.findNextAvailableAppointment(this.weekStart)));
    }
    var timesElements = _widgetController.widgetCtrl.getBookingsForDay(day, location.bookings).filter(function (item, i, times) {
      if (times[i + 1]) {
        return item.start_datetime !== times[i + 1].start_datetime;
      }
      return true;
    }).map(function (item) {
      var timeText = findTimeText(item.automation, item.start_datetime);
      var el = (0, _domHelpers.createEl)('div', _calendar2.default.time, timeText);
      el.addEventListener('click', _analytics.onAppointmentClick);
      el.addEventListener('click', function () {
        return _widgetModal2.default.onAppointmentTimeClick(item);
      });
      return el;
    });
    this.timesInstruction.innerHTML = day.format('dddd, MMMM Do') + ' - ' + location.name;
    if (timesElements.length) {
      var _times;

      this.times.innerHTML = '';
      (_times = this.times).append.apply(_times, _toConsumableArray(timesElements));
      (0, _domHelpers.toggle)(this.overlay, this.timesContainer);
      return Promise.resolve(true);
    }
    return Promise.resolve(this.renderOverlay('day', _widgetController.widgetCtrl.findNextAvailableAppointment(day)));
  },
  render: function render() {
    var _this5 = this;

    var currentDay = void 0;
    if (!_widgetController.widgetCtrl.getCurrentDay()) {
      currentDay = (0, _momentTimezone2.default)().tz(_widgetController.widgetCtrl.getTz()).startOf('day');
      this.weekStart = (0, _momentTimezone2.default)().tz(_widgetController.widgetCtrl.getTz()).startOf('week');
      this.weekIndex = 0;
      (0, _domHelpers.scrollTo)(this.week, 0);
      _widgetController.widgetCtrl.setCurrentDay(currentDay);
    } else {
      currentDay = _widgetController.widgetCtrl.getCurrentDay();
    }
    this.toggleWeekArrows();
    this.markAvailableDays();
    this.renderTimes().then(function () {
      _this5.selectDay(_this5.week.childNodes[currentDay.day() + _this5.weekIndex * 7], currentDay);
    });
  }
};

exports.default = calendar;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ravenJs = __webpack_require__(3);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _calendarView = __webpack_require__(46);

var _calendarView2 = _interopRequireDefault(_calendarView);

var _appointmentView = __webpack_require__(53);

var _appointmentView2 = _interopRequireDefault(_appointmentView);

var _domHelpers = __webpack_require__(1);

var _widgetController = __webpack_require__(0);

var _setColors = __webpack_require__(11);

var _widgetModal = __webpack_require__(13);

var _widgetModal2 = _interopRequireDefault(_widgetModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetModal = {
  init: function init() {
    this.spinner = (0, _domHelpers.createEl)('div', _widgetModal2.default.spinner);
    this.error = (0, _domHelpers.createEl)('div', _widgetModal2.default.error);
    var errorOk = (0, _domHelpers.createEl)('button', _widgetModal2.default.errorButton, 'OK');
    this.error.append((0, _domHelpers.createEl)('p', _widgetModal2.default.errorText, 'Sorry, something went wrong. \nPlease try again.'), errorOk);
    errorOk.addEventListener('click', this.render.bind(this));

    this.calendarViewElem = _calendarView2.default.init();
    this.appointmentViewElem = _appointmentView2.default.init();
    var modalContainer = (0, _domHelpers.createEl)('div', _widgetModal2.default.container);

    var body = (0, _domHelpers.createEl)('div', _widgetModal2.default.body);
    body.append(this.calendarViewElem, this.appointmentViewElem);
    var header = (0, _setColors.setPrimaryColors)((0, _domHelpers.createEl)('div', _widgetModal2.default.header));
    var closeX = (0, _setColors.setPrimaryFontColor)((0, _domHelpers.createBtn)(_widgetModal2.default.closeBtn, 'close'));
    var name = (0, _setColors.setPrimaryFontColor)((0, _domHelpers.createEl)('h2', _widgetModal2.default.officeName, _widgetController.widgetCtrl.getPracticeName()));
    header.append(name, closeX);

    this.modal = (0, _domHelpers.createEl)('div', _widgetModal2.default.modal);
    this.modal.append(header, (0, _domHelpers.createEl)('div', _widgetModal2.default.divider), body);

    var themeClass = (0, _setColors.getThemeClass)();
    this.modal.className += ' ' + themeClass;

    modalContainer.append(this.modal, this.spinner, this.error);
    return modalContainer;
  },
  toggleSpinner: function toggleSpinner() {
    this.spinner.style.display = this.spinner.style.display === 'block' ? 'none' : 'block';
  },
  showError: function showError(errorText) {
    this.error.childNodes[0].textContent = errorText;
    this.error.style.display = 'flex';
    this.modal.style.filter = 'blur(3px)';
  },
  onAppointmentTimeClick: function onAppointmentTimeClick(booking) {
    var _this = this;

    // Google Analytics:
    if (true) {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Calendar',
        eventAction: 'timeSelect'
      });
    }
    this.toggleSpinner();
    _widgetController.widgetCtrl.holdBooking(booking).then(function () {
      (0, _domHelpers.toggle)(widgetModal.calendarViewElem, widgetModal.appointmentViewElem);
      _appointmentView2.default.render();
      setTimeout(_this.toggleSpinner.bind(_this), 100);
    }).catch(function (err) {
      _ravenJs2.default.captureException(err);
    });
  },
  onEditAppointmentClick: function onEditAppointmentClick() {
    // Google Analytics:
    if (true) {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Form',
        eventAction: 'back'
      });
    }
    (0, _domHelpers.toggle)(widgetModal.appointmentViewElem, widgetModal.calendarViewElem);
    window.dispatchEvent(new Event('resize'));
  },
  render: function render() {
    this.spinner.style.display = 'none';
    this.error.style.display = 'none';
    this.modal.style.filter = 'blur(0px)';
    (0, _domHelpers.toggle)(this.appointmentViewElem, this.calendarViewElem);
    _appointmentView2.default.clearForm();
    _calendarView2.default.render();
  }
}; /* global ga */

exports.default = widgetModal;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var widgetDiv = document.getElementById('openchair-widget');

var setPrimaryColors = exports.setPrimaryColors = function setPrimaryColors(el) {
  var primaryColor = widgetDiv.dataset.primarycolor;
  if (primaryColor) {
    el.style.background = primaryColor;
  }
  return el;
};

var setPrimaryFontColor = exports.setPrimaryFontColor = function setPrimaryFontColor(el) {
  var primaryFontColor = widgetDiv.dataset.primarycolortext;
  if (primaryFontColor) {
    el.style.color = primaryFontColor;
  }
  return el;
};

var getThemeClass = exports.getThemeClass = function getThemeClass() {
  var theme = widgetDiv.dataset.theme;
  return theme === 'dark' ? 'openChair__darkTheme' : 'openChair__lightTheme';
};

var setBorder = function setBorder(daySelector, secondaryColor) {
  var allElements = document.getElementsByClassName(daySelector);
  Array.from(allElements).forEach(function (node) {
    node.style.borderColor = secondaryColor;
  });
};

var setFontColor = function setFontColor(el) {
  var secondaryFontColor = widgetDiv.dataset.secondarycolortext;
  el.style.color = secondaryFontColor;
};

var setSecondaryColor = exports.setSecondaryColor = function setSecondaryColor(el, daySelector) {
  var secondaryColor = widgetDiv.dataset.secondarycolor;

  if (secondaryColor) {
    el.style.background = secondaryColor;
    setFontColor(el);
    setBorder(daySelector, secondaryColor);
  }
};

var hideMainButton = exports.hideMainButton = function hideMainButton() {
  return !!widgetDiv.dataset.hidebutton;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(52);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"attrs":{"id":"widget-styles"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./widgetModal.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./widgetModal.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".openchair_appointmentView__appointmentInfoView--3aKt8{width:100%;height:100%;display:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.openchair_appointmentView__appointmentInfoSubView--gFFKD{height:85%}.openchair_appointmentView__infoContainer--2CsYd{width:100%;height:80%;padding:0 32px}.openchair_appointmentView__form--3AEbB,.openchair_appointmentView__infoContainer--2CsYd{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.openchair_appointmentView__form--3AEbB{height:100%;width:50%;margin:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-transform:none}.openchair_appointmentView__formInputRow--3xCJ_{width:100%;height:28px;min-height:28px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:2%;-webkit-box-sizing:border-box;box-sizing:border-box;text-transform:none}.openchair_appointmentView__formLabel--27Z65{font-family:Lato,sans-serif;font-size:12px;font-size:calc(10.78261px + .17391vw);text-align:right;line-height:24px;vertical-align:middle;text-transform:none;font-weight:400}.openchair_appointmentView__formLabel--27Z65:after{content:\":\"}.openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5{width:60%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0 2%;padding:2px 6px;border:none;border-bottom:2px solid hsla(0,0%,97%,.5);border-radius:0;background-color:transparent;font-family:Lato,sans-serif;font-size:12px;font-size:calc(10.78261px + .17391vw);text-transform:none}.openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5:focus{background-color:inherit}.openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5::-webkit-input-placeholder{color:#f8f8f8;color:hsla(0,0%,97%,.6);font-size:12px;font-size:calc(10.78261px + .17391vw);text-transform:none}.openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5:-ms-input-placeholder{color:#f8f8f8;color:hsla(0,0%,97%,.6);font-size:12px;font-size:calc(10.78261px + .17391vw);text-transform:none}.openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5::placeholder{color:#f8f8f8;color:hsla(0,0%,97%,.6);font-size:12px;font-size:calc(10.78261px + .17391vw);text-transform:none}.openchair_appointmentView__bookingContainer--2y_9b{width:50%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding-left:2%}.openchair_appointmentView__bookingRow--1yEr5{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;line-height:normal}.openchair_appointmentView__bookingLabel--ouyk9{width:20%;padding:2px;-ms-flex-negative:0;flex-shrink:0;text-align:right;font-family:Lato,sans-serif;font-size:12px;font-size:calc(10.78261px + .17391vw)}.openchair_appointmentView__bookingLabel--ouyk9:after{content:\":\";font-family:Lato,sans-serif;font-size:12px;font-size:calc(10.78261px + .17391vw)}.openchair_appointmentView__bookingValue--qAM6p{padding:2px 4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.openchair_appointmentView__bookingValueLine--2wTLN{font-family:Lato,sans-serif;font-size:12px;font-size:calc(10.78261px + .17391vw);text-align:left;font-weight:400}.openchair_appointmentView__bookingValueLine--2wTLN:first-child{font-weight:700;font-size:14px;font-size:calc(12.78261px + .17391vw)}.openchair_appointmentView__patientLabel--2n7su{width:33%}.openchair_appointmentView__patientValue--2ER9C{padding:2px 4px;font-weight:700;font-size:14px;font-size:calc(12.78261px + .17391vw)}.openchair_appointmentView__patientValueMessage--2qdTe{max-height:50px;overflow-y:auto;font-weight:400;font-size:12px;font-size:calc(10.78261px + .17391vw)}.openchair_appointmentView__buttonsContainer--3UCbz{height:15%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;position:absolute;bottom:16%;left:0}.openchair_appointmentView__button--1kMVg{width:250px;height:38px;margin:0;padding:0;border:none;text-transform:uppercase;font-family:Lato,sans-serif}.openchair_appointmentView__button--1kMVg:focus,.openchair_appointmentView__button--1kMVg:hover{opacity:.8;border:none}.openchair_appointmentView__buttonCancel--I5evS{-ms-flex-item-align:center;align-self:center;background-color:transparent;color:#f8f8f8;cursor:pointer;font-size:14px;letter-spacing:1.5px}.openchair_appointmentView__buttonCancel--I5evS:focus,.openchair_appointmentView__buttonCancel--I5evS:hover{background-color:transparent}.openchair_appointmentView__buttonConfirm--3Rgl7{background-color:#f8f8f8;border-radius:20px;cursor:pointer;font-size:14px;font-size:calc(12.78261px + .17391vw);font-weight:700;color:#696969;letter-spacing:2px}.openchair_appointmentView__buttonConfirm--3Rgl7:focus,.openchair_appointmentView__buttonConfirm--3Rgl7:hover{background-color:#f8f8f8;color:#696969}.openchair_appointmentView__calendars--GqRvx{width:250px;display:none;-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around;position:relative;top:4px}.openchair_appointmentView__calendarBtn--92T_M,.openchair_appointmentView__calendars--GqRvx{-webkit-box-direction:normal;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.openchair_appointmentView__calendarBtn--92T_M{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:46px;height:46px;text-align:center;border-radius:50%},.openchair_appointmentView__calendarBtn--92T_M:focus,.openchair_appointmentView__calendarBtn--92T_M:hover{opacity:.8;border:none}.openchair_appointmentView__calendarIcon--d2ZBF{width:30px;height:30px;filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0\" /></filter></svg>#filter');-webkit-filter:grayscale(100%);filter:grayscale(100%)}.openchair_appointmentView__calendarName--3IRjV{font-size:10px;font-size:calc(8.78261px + .17391vw);color:#f8f8f8;font-weight:700;text-transform:uppercase;display:none}.openchair_appointmentView__footer--1xnep{width:100%;height:8%;padding:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:auto}.openchair_appointmentView__footerText--3c0kJ{font-family:Lato,sans-serif;font-weight:300;font-size:12px;font-size:calc(10.78261px + .17391vw)}.openchair_appointmentView__footerLogo--1QXL3{height:12px;height:calc(10.78261px + .17391vw);font-size:12px;font-size:calc(10.78261px + .17391vw);margin:0 5px;max-width:14px}.openchair_appointmentView__confirmMessage--36R_K{width:55%;min-width:400px;max-width:500px;display:block;text-align:center}.openchair_appointmentView__confirmMessageLine--1VmK-{display:\"inline\";font-family:Lato,sans-serif;font-size:14px;font-size:calc(12.78261px + .17391vw);font-weight:400;line-height:1.25;margin:6px auto;max-width:400px}.openchair_appointmentView__confirmMessage--36R_K .openchair_appointmentView__confirmMessageLine--1VmK-:first-child{width:80%;display:block;font-size:18px;font-size:calc(16.78261px + .17391vw);font-weight:700}.openchair_appointmentView__recaptcha--2ZdJG{width:100%;position:absolute;top:104%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.openchair_appointmentView__recaptchaLine--3LvKB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding-top:4px;font-family:Lato,sans-serif;font-size:10px;font-size:calc(8.78261px + .17391vw);color:#f8f8f8;font-weight:400}.openchair_appointmentView__recaptchaLink--zz675{font-family:Lato,sans-serif;color:#f8f8f8;padding:0 4px;font-weight:400;font-size:smaller;text-decoration:none}.openchair_appointmentView__recaptchaLink--zz675:hover{text-decoration:underline}.openchair_appointmentView__extraQuestionBlock--1gZ98{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.openchair_appointmentView__radioLabel--1abP9{font-family:Lato,sans-serif;font-size:12px;font-size:calc(10.78261px + .17391vw);text-transform:none;padding:4px;font-weight:400}.openchair_appointmentView__dropdown--eFJje{color:#696969;font-size:12px;font-size:calc(10.78261px + .17391vw)}.openchair_appointmentView__messageSection--32Z0n{compose:bookingRow;margin-top:20px}.openchair_appointmentView__formFieldList--1XChj{list-style:none;counter-reset:line;padding:0;margin-left:27px}.openchair_appointmentView__automationH2--SzEc4{font-size:17px;margin:14px 0;text-transform:none}.openchair_appointmentView__appointmentDetails--1Ns1x{font-size:16px;font-weight:700}.openchair_appointmentView__lookGood--1EqzL{font-size:16px;font-weight:700;margin:0 0 10px 13px}.openchair_appointmentView__automationMessage--2KYDP{font-size:16px;line-height:normal;margin:16px 0}.openChair__lightTheme .openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5{border-bottom:1.2px solid #696969}.openChair__lightTheme .openchair_appointmentView__buttonConfirm--3Rgl7{background-color:#696969;color:#fbfbfb}.openChair__lightTheme .openchair_appointmentView__buttonConfirm--3Rgl7:hover{background-color:#696969;background-color:hsla(0,0%,41%,.5)}.openChair__lightTheme .openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5::-webkit-input-placeholder{color:#696969;color:hsla(0,0%,41%,.5)}.openChair__lightTheme .openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5:-ms-input-placeholder{color:#696969;color:hsla(0,0%,41%,.5)}.openChair__lightTheme .openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5::placeholder{color:#696969;color:hsla(0,0%,41%,.5)}.openChair__lightTheme .openchair_appointmentView__buttonCancel--I5evS{color:#696969}.openChair__lightTheme .openchair_appointmentView__footerLogo--1QXL3{display:none}@media only screen and (max-width:768px){.openchair_appointmentView__appointmentInfoView--3aKt8{display:block;-ms-flex-pack:distribute;justify-content:space-around;margin:0}.openchair_appointmentView__appointmentInfoSubView--gFFKD{height:85%}.openchair_appointmentView__divider--1tWE5{width:25%;height:1px;margin-bottom:4px}.openchair_appointmentView__infoContainer--2CsYd{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:60%;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;padding:0 14px}.openchair_appointmentView__form--3AEbB{display:block;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding-top:22px;width:100%}.openchair_appointmentView__formInputRow--3xCJ_{height:35px}.openchair_appointmentView__formLabel--27Z65{width:30%;margin-left:0;font-size:14px}.openchair_appointmentView__form--3AEbB .openchair_appointmentView__formTextInput--bByt5{border-bottom:1.2px solid hsla(0,0%,97%,.8);-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;font-size:12px;width:100%}.openchair_appointmentView__bookingContainer--2y_9b{margin-top:30px;padding:0;width:100%}.openchair_appointmentView__patientContainer--2xfNK{display:block;width:100%}.openchair_appointmentView__buttonsContainer--3UCbz{display:block;height:auto;margin-top:40px;position:static}.openchair_appointmentView__bookingContainer--2y_9b{display:block;height:inherit}.openchair_appointmentView__bookingLabel--ouyk9{width:30%;font-size:12px}.openchair_appointmentView__bookingValueLine--2wTLN,.openchair_appointmentView__bookingValueLine--2wTLN:first-child{font-size:14px;padding:0 4px}.openchair_appointmentView__buttonSubmit--1KGgN{font-size:14px}.openchair_appointmentView__button--1kMVg{display:block;margin:0 auto}.openchair_appointmentView__footer--1xnep{display:block;margin-top:0;padding:0;text-align:center;height:auto}.openchair_appointmentView__footerLogo--1QXL3,.openchair_appointmentView__footerText--3c0kJ{font-size:10px}.openchair_appointmentView__confirmMessage--36R_K{min-width:70%}.openchair_appointmentView__confirmMessageLine--1VmK-{font-size:12px}.openchair_appointmentView__confirmMessage--36R_K .openchair_appointmentView__confirmMessageLine--1VmK-:first-child{width:242px;font-size:14px}}", ""]);

// exports
exports.locals = {
	"appointmentInfoView": "openchair_appointmentView__appointmentInfoView--3aKt8",
	"appointmentInfoSubView": "openchair_appointmentView__appointmentInfoSubView--gFFKD openchair_appointmentView__appointmentInfoView--3aKt8",
	"infoContainer": "openchair_appointmentView__infoContainer--2CsYd",
	"form": "openchair_appointmentView__form--3AEbB",
	"formInputRow": "openchair_appointmentView__formInputRow--3xCJ_",
	"formLabel": "openchair_appointmentView__formLabel--27Z65",
	"formTextInput": "openchair_appointmentView__formTextInput--bByt5",
	"bookingContainer": "openchair_appointmentView__bookingContainer--2y_9b",
	"bookingRow": "openchair_appointmentView__bookingRow--1yEr5",
	"bookingLabel": "openchair_appointmentView__bookingLabel--ouyk9",
	"bookingValue": "openchair_appointmentView__bookingValue--qAM6p",
	"bookingValueLine": "openchair_appointmentView__bookingValueLine--2wTLN",
	"patientContainer": "openchair_appointmentView__patientContainer--2xfNK openchair_appointmentView__bookingContainer--2y_9b",
	"patientRow": "openchair_appointmentView__patientRow--3cr1L openchair_appointmentView__bookingRow--1yEr5",
	"patientLabel": "openchair_appointmentView__patientLabel--2n7su openchair_appointmentView__bookingLabel--ouyk9",
	"patientValue": "openchair_appointmentView__patientValue--2ER9C openchair_appointmentView__bookingValueLine--2wTLN",
	"patientValueMessage": "openchair_appointmentView__patientValueMessage--2qdTe openchair_appointmentView__bookingValueLine--2wTLN",
	"buttonsContainer": "openchair_appointmentView__buttonsContainer--3UCbz",
	"button": "openchair_appointmentView__button--1kMVg",
	"buttonCancel": "openchair_appointmentView__buttonCancel--I5evS openchair_appointmentView__button--1kMVg",
	"buttonConfirm": "openchair_appointmentView__buttonConfirm--3Rgl7 openchair_appointmentView__button--1kMVg",
	"calendars": "openchair_appointmentView__calendars--GqRvx",
	"calendarBtn": "openchair_appointmentView__calendarBtn--92T_M",
	"calendarIcon": "openchair_appointmentView__calendarIcon--d2ZBF",
	"calendarName": "openchair_appointmentView__calendarName--3IRjV",
	"footer": "openchair_appointmentView__footer--1xnep",
	"footerText": "openchair_appointmentView__footerText--3c0kJ",
	"footerLogo": "openchair_appointmentView__footerLogo--1QXL3",
	"confirmMessage": "openchair_appointmentView__confirmMessage--36R_K",
	"confirmMessageLine": "openchair_appointmentView__confirmMessageLine--1VmK-",
	"recaptcha": "openchair_appointmentView__recaptcha--2ZdJG",
	"recaptchaLine": "openchair_appointmentView__recaptchaLine--3LvKB",
	"recaptchaLink": "openchair_appointmentView__recaptchaLink--zz675",
	"extraQuestionBlock": "openchair_appointmentView__extraQuestionBlock--1gZ98",
	"radioLabel": "openchair_appointmentView__radioLabel--1abP9",
	"dropdown": "openchair_appointmentView__dropdown--eFJje",
	"messageSection": "openchair_appointmentView__messageSection--32Z0n",
	"formFieldList": "openchair_appointmentView__formFieldList--1XChj",
	"automationH2": "openchair_appointmentView__automationH2--SzEc4",
	"appointmentDetails": "openchair_appointmentView__appointmentDetails--1Ns1x",
	"lookGood": "openchair_appointmentView__lookGood--1EqzL",
	"automationMessage": "openchair_appointmentView__automationMessage--2KYDP",
	"divider": "openchair_appointmentView__divider--1tWE5",
	"buttonSubmit": "openchair_appointmentView__buttonSubmit--1KGgN"
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"attrs":{"id":"widget-styles"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./appointmentView.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./appointmentView.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isObject(what) {
    return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

function wrappedCallback(callback) {
    function dataCallback(data, original) {
      var normalizedData = callback(data) || data;
      if (original) {
          return original(normalizedData) || normalizedData;
      }
      return normalizedData;
    }

    return dataCallback;
}

module.exports = {
    isObject: isObject,
    isError: isError,
    wrappedCallback: wrappedCallback
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBookings = getBookings;
exports.putBooking = putBooking;
exports.postAppointment = postAppointment;
exports.postEvent = postEvent;

__webpack_require__(16);

// TODO: set up production route
var url =  true ? 'https://roosterreminders.com:3001/api/v1/bookings' : 'http://localhost:3001/api/v1/bookings';

var eventUrl =  true ? 'https://roosterreminders.com:3001/api/v1/interaction_events' : 'http://localhost:3001/api/v1/interaction_events';

var headers = {
  Accept: 'application/json'
};

function getBookings(start, end, key) {
  // e.g. start=01-01-2017&end=01-01-2018
  if (key) {
    headers.Authorization = key;
  }
  if (!headers.Authorization) {
    return Promise.reject(new Error('no token present'));
  }
  return fetch(url + '?consumer=widget&start=' + start.format('DD-MM-YYYY') + '&end=' + end.format('DD-MM-YYYY'), { headers: headers }).then(function (res) {
    var data = res.json();
    if (res.ok) {
      return data;
    }
    return Promise.reject(JSON.stringify({
      status: res.status,
      data: data,
      token: headers.Authorization
    }));
  });
}

function putBooking(bookingId, status) {
  return fetch(url + '/' + bookingId, {
    method: 'PUT',
    body: JSON.stringify({ status: status }),
    headers: headers
  }).then(function (res) {
    var data = res.json();
    if (res.ok) {
      return data;
    }
    return Promise.reject(JSON.stringify({ status: res.status, data: data }));
  });
}

function postAppointment(body) {
  return fetch(url + '/booking_success', {
    method: 'POST',
    body: body,
    headers: headers
  }).then(function (res) {
    var data = res.json();
    if (res.ok) {
      return data;
    }
    return Promise.reject(JSON.stringify({ status: res.status, data: data }));
  });
}

var eventHeader = {
  'Content-Type': 'application/json'
};

function postEvent(body) {
  eventHeader.Authorization = headers.Authorization;
  return fetch(eventUrl, {
    method: 'POST',
    body: body,
    headers: eventHeader
  }).then(function (res) {
    return res.json();
  }).then(function (res) {
    return res;
  });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ravenJs = __webpack_require__(3);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _widgetController = __webpack_require__(0);

var _domHelpers = __webpack_require__(1);

var _analytics = __webpack_require__(7);

var _calendar = __webpack_require__(9);

var _calendar2 = _interopRequireDefault(_calendar);

var _locations = __webpack_require__(50);

var _locations2 = _interopRequireDefault(_locations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GOOGLE_MAPS_KEY = 'AIzaSyDXe1z6Mj3LZSvBnleor9h-zdikTfGqd_M';
// TODO: do this on the backend once for each practice
function geocodeLocations(locations) {
  var geocoder = new google.maps.Geocoder();
  function geocodeAddress(address) {
    return new Promise(function (resolve, reject) {
      geocoder.geocode({ address: address }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results[0].geometry.location);
        } else {
          reject(status);
        }
      });
    });
  }
  return Promise.all(locations.map(function (loc) {
    return geocodeAddress(loc.street_address + ', ' + loc.city + ', ' + loc.state + ' ' + loc.zip);
  }));
}

var mapView = {
  init: function init() {
    var _this = this;

    this.map = null;
    this.markers = [];
    var mapDiv = (0, _domHelpers.createEl)('div', _locations2.default.map);

    var mapLoader = (0, _domHelpers.createScript)('https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_MAPS_KEY);
    mapLoader.onload = function () {
      _this.initMap(mapDiv);
    };
    document.body.append(mapLoader);

    var locationsContainer = (0, _domHelpers.createEl)('div', _locations2.default.locations);

    // // create map instruction and info boxes for desktop:
    var desktopInfoTopBox = (0, _domHelpers.createEl)('div', _locations2.default.desktopTopBox, 'Click on the icons to change locations');
    this.desktopInfoBottomBox = (0, _domHelpers.createEl)('div', _locations2.default.desktopBottomBox);

    // create open/close map button for mobile:
    var mobileMapToogle = (0, _domHelpers.createEl)('div', _locations2.default.selectToggle);
    var toggleArrow = (0, _domHelpers.createEl)('div', _locations2.default.toggleArrow, 'arrow_drop_up');
    var toggleText = (0, _domHelpers.createEl)('span', _locations2.default.toggleLine);
    toggleText.append((0, _domHelpers.createEl)('span', _locations2.default.toggleText, _widgetController.widgetCtrl.getLocations().length > 1 ? 'choose location' : 'show map'), toggleArrow);
    mobileMapToogle.append(toggleText);
    var toggleState = _locations2.default.isExpanded;

    mobileMapToogle.addEventListener('click', function () {
      (0, _domHelpers.removeClass)(locationsContainer, toggleState);
      toggleState = toggleState === _locations2.default.isExpanded ? _locations2.default.isHidden : _locations2.default.isExpanded;

      locationsContainer.className += ' ' + toggleState;
      toggleArrow.textContent = toggleArrow.textContent === 'arrow_drop_up' ? 'arrow_drop_down' : 'arrow_drop_up';
    });
    if (_widgetController.widgetCtrl.getLocations().length > 1) {
      locationsContainer.append(desktopInfoTopBox);
    }
    locationsContainer.append(mobileMapToogle, mapDiv, this.desktopInfoBottomBox);
    return locationsContainer;
  },
  initMap: function initMap(mapDiv) {
    var _this2 = this;

    geocodeLocations(_widgetController.widgetCtrl.getLocations()).then(function (values) {
      _this2.map = new google.maps.Map(mapDiv, {
        zoom: 6,
        center: { lat: 0, lng: 0 },
        clickableIcons: false,
        disableDefaultUI: true,
        zoomControl: true,
        maxZoom: 12
      });

      // this piece ensures map is displayed properly after being hidden
      var bounds = new google.maps.LatLngBounds();
      values.forEach(function (v) {
        bounds.extend(v);
      });
      google.maps.event.addDomListener(window, 'resize', function () {
        google.maps.event.trigger(_this2.map, 'resize');
        _this2.map.setOptions({ maxZoom: 12 });
        if (_widgetController.widgetCtrl.getLocations().length > 1) {
          _this2.map.fitBounds(bounds);
        }
        _this2.map.setOptions({ maxZoom: undefined });
      });
      _this2.map.fitBounds(bounds);
      _widgetController.widgetCtrl.setLatLngForLocations(values);
      _this2.initMarkers();
      _this2.render();
    }).catch(function (err) {
      _widgetController.widgetCtrl.showError();
      _ravenJs2.default.captureException(JSON.stringify(err));
    });
  },
  initMarkers: function initMarkers() {
    var _this3 = this;

    _widgetController.widgetCtrl.getLocations().forEach(function (location) {
      var marker = new google.maps.Marker({
        position: location.latLng,
        map: _this3.map,
        zIndex: 10,
        clickable: true,
        title: location.name,
        icon: {
          url: __webpack_require__(12),
          labelOrigin: new google.maps.Point(27, 22),
          scaledSize: new google.maps.Size(56, 60.5)
        }
      });

      marker.addListener('click', function () {
        // Google Analytics:
        if (true) {
          ga('openchair.send', {
            hitType: 'event',
            eventCategory: 'Calendar',
            eventAction: 'locationSelect'
          });
        }
        (0, _analytics.onMapClick)();
        _widgetController.widgetCtrl.setCurrentLocation(location);
        _this3.render();
        _calendar2.default.render();
      });
      _this3.markers.push({ marker: marker, location: location });
    });
  },
  render: function render() {
    var currentLocation = _widgetController.widgetCtrl.getCurrentLocation();
    var indicatorData = _widgetController.widgetCtrl.getNumberBookingsAvailableForLocations();
    this.desktopInfoBottomBox.innerHTML = '';
    this.desktopInfoBottomBox.append((0, _domHelpers.createEl)('span', _locations2.default.address, 'Office address:\n'), (0, _domHelpers.createEl)('span', _locations2.default.address, currentLocation.street_address + '\n' + currentLocation.city + ', ' + currentLocation.state + ' ' + currentLocation.zip));
    this.markers.forEach(function (_ref) {
      var marker = _ref.marker,
          location = _ref.location;

      var indicator = indicatorData[location.id]; // has to have a space otherwise google returns [object Object]
      marker.setLabel({
        text: '' + (indicator || ' '),
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        fontFamily: 'Lato'
      });
      marker.setTitle((indicator || 'No') + ' appointment' + (indicator === 1 ? '' : 's') + ' \navailable at ' + location.name + ' this week');
      if (marker.position === currentLocation.latLng) {
        marker.setOptions({ opacity: 1 });
        marker.setIcon({
          url: __webpack_require__(12),
          labelOrigin: new google.maps.Point(27, 22),
          scaledSize: new google.maps.Size(56, 60.5)
        });
      } else {
        marker.setOptions({ opacity: 0.75 });
        marker.setIcon({
          url: __webpack_require__(12),
          labelOrigin: new google.maps.Point(20, 18),
          scaledSize: new google.maps.Size(42, 46)
        });
      }
    });
  }
};

exports.default = mapView;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(16);
module.exports = __webpack_require__(21);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promisePolyfill = __webpack_require__(22);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// To add to window
if (!window.Promise) {
  window.Promise = _promisePolyfill2.default;
} // wrap everything in an anonymous function to avoid any conflicts with other js in the page


(function (window, undefined) {
  var NODE_ENV = "production";

  var SENTRY_KEY = 'https://ea5ec4ef978e46f28c460aa12e12a2bd@sentry.io/223105';
  var initOpenchair = void 0;
  // init raven
  if (NODE_ENV === 'production') {
    var Raven = __webpack_require__(3);
    Raven.config(SENTRY_KEY, {
      environment: NODE_ENV
    }).install();
    // it's a backup for any uncaught errors in promises - only works in latest chrome (not localhost) and safari
    window.addEventListener('unhandledrejection', function (evt) {
      Raven.captureException(evt.reason);
    });
    initOpenchair = function initOpenchair() {
      Raven.context(function () {
        var ctrl = __webpack_require__(0).widgetCtrl;
        ctrl.init();
      });
    };
  } else {
    initOpenchair = function initOpenchair() {
      var ctrl = __webpack_require__(0).widgetCtrl;
      ctrl.init();
    };
  }

  // get polyfills
  var polyfillScript = document.createElement('script');
  polyfillScript.src = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=default,fetch';
  polyfillScript.async = true;
  polyfillScript.onload = initOpenchair;
  var entry = document.getElementsByTagName('script')[0];
  entry.parentNode.insertBefore(polyfillScript, entry);

  var gaScript = document.createElement('script');
  gaScript.innerHTML = "window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;ga('create', 'UA-108005724-1', 'auto', 'openchair');ga('require', 'GTM-TJF2DWV');ga('openchair.send', 'pageview', location.hash);";
  var gaScriptLoader = document.createElement('script');
  gaScriptLoader.src = 'https://www.google-analytics.com/analytics.js';
  gaScriptLoader.async = true;

  entry.parentNode.appendChild(gaScript);
  entry.parentNode.appendChild(gaScriptLoader);
})(window);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);

    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).setImmediate))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(24);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(25)))

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false, __DEV__:false*/


var TraceKit = __webpack_require__(27);
var stringify = __webpack_require__(28);
var RavenConfigError = __webpack_require__(29);
var utils = __webpack_require__(17);

var isError = utils.isError,
    isObject = utils.isObject;

var wrapConsoleMethod = __webpack_require__(30).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
    return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _document = _window.document;
var _navigator = _window.navigator;


function keepOriginalCallback(original, callback) {
    return isFunction(callback) ?
    function (data) { return callback(data, original) } :
    callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
    // Raven can run in contexts where there's no document (react-native)
    this._hasDocument = !isUndefined(_document);
    this._hasNavigator = !isUndefined(_navigator);
    this._lastCapturedException = null;
    this._lastData = null;
    this._lastEventId = null;
    this._globalServer = null;
    this._globalKey = null;
    this._globalProject = null;
    this._globalContext = {};
    this._globalOptions = {
        logger: 'javascript',
        ignoreErrors: [],
        ignoreUrls: [],
        whitelistUrls: [],
        includePaths: [],
        crossOrigin: 'anonymous',
        collectWindowErrors: true,
        maxMessageLength: 0,

        // By default, truncates URL values to 250 chars
        maxUrlLength: 250,
        stackTraceLimit: 50,
        autoBreadcrumbs: true,
        instrument: true,
        sampleRate: 1
    };
    this._ignoreOnError = 0;
    this._isRavenInstalled = false;
    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
    // capture references to window.console *and* all its methods first
    // before the console plugin has a chance to monkey patch
    this._originalConsole = _window.console || {};
    this._originalConsoleMethods = {};
    this._plugins = [];
    this._startTime = now();
    this._wrappedBuiltIns = [];
    this._breadcrumbs = [];
    this._lastCapturedEvent = null;
    this._keypressTimeout;
    this._location = _window.location;
    this._lastHref = this._location && this._location.href;
    this._resetBackoff();

    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
      this._originalConsoleMethods[method] = this._originalConsole[method];
    }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
    // Hardcode version string so that raven source can be loaded directly via
    // webpack (using a build step causes webpack #1617). Grunt verifies that
    // this value matches package.json during build.
    //   See: https://github.com/getsentry/raven-js/issues/465
    VERSION: '3.17.0',

    debug: false,

    TraceKit: TraceKit, // alias to TraceKit

    /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Optional set of of global options [optional]
     * @return {Raven}
     */
    config: function(dsn, options) {
        var self = this;

        if (self._globalServer) {
                this._logDebug('error', 'Error: Raven has already been configured');
            return self;
        }
        if (!dsn) return self;

        var globalOptions = self._globalOptions;

        // merge in options
        if (options) {
            each(options, function(key, value){
                // tags and extra are special and need to be put into context
                if (key === 'tags' || key === 'extra' || key === 'user') {
                    self._globalContext[key] = value;
                } else {
                    globalOptions[key] = value;
                }
            });
        }

        self.setDSN(dsn);

        // "Script error." is hard coded into browsers for errors that it can't read.
        // this is the result of a script being pulled in from an external domain and CORS.
        globalOptions.ignoreErrors.push(/^Script error\.?$/);
        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

        // join regexp rules into one big rule
        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
        globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100

        var autoBreadcrumbDefaults = {
            xhr: true,
            console: true,
            dom: true,
            location: true
        };

        var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
        } else if (autoBreadcrumbs !== false) {
            autoBreadcrumbs = autoBreadcrumbDefaults;
        }
        globalOptions.autoBreadcrumbs = autoBreadcrumbs;

        var instrumentDefaults = {
            tryCatch: true
        };

        var instrument = globalOptions.instrument;
        if ({}.toString.call(instrument) === '[object Object]') {
            instrument = objectMerge(instrumentDefaults, instrument);
        } else if (instrument !== false) {
            instrument = instrumentDefaults;
        }
        globalOptions.instrument = instrument;

        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

        // return for chaining
        return self;
    },

    /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
    install: function() {
        var self = this;
        if (self.isSetup() && !self._isRavenInstalled) {
            TraceKit.report.subscribe(function () {
                self._handleOnErrorStackInfo.apply(self, arguments);
            });
            if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
              self._instrumentTryCatch();
            }

            if (self._globalOptions.autoBreadcrumbs)
                self._instrumentBreadcrumbs();

            // Install all of the plugins
            self._drainPlugins();

            self._isRavenInstalled = true;
        }

        Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
        return this;
    },

    /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
    setDSN: function(dsn) {
        var self = this,
            uri = self._parseDSN(dsn),
          lastSlash = uri.path.lastIndexOf('/'),
          path = uri.path.substr(1, lastSlash);

        self._dsn = dsn;
        self._globalKey = uri.user;
        self._globalSecret = uri.pass && uri.pass.substr(1);
        self._globalProject = uri.path.substr(lastSlash + 1);

        self._globalServer = self._getGlobalServer(uri);

        self._globalEndpoint = self._globalServer +
            '/' + path + 'api/' + self._globalProject + '/store/';

        // Reset backoff state since we may be pointing at a
        // new project/server
        this._resetBackoff();
    },

    /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
    context: function(options, func, args) {
        if (isFunction(options)) {
            args = func || [];
            func = options;
            options = undefined;
        }

        return this.wrap(options, func).apply(this, args);
    },

    /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
    wrap: function(options, func, _before) {
        var self = this;
        // 1 argument has been passed, and it's not a function
        // so just return it
        if (isUndefined(func) && !isFunction(options)) {
            return options;
        }

        // options is optional
        if (isFunction(options)) {
            func = options;
            options = undefined;
        }

        // At this point, we've passed along 2 arguments, and the second one
        // is not a function either, so we'll just return the second argument.
        if (!isFunction(func)) {
            return func;
        }

        // We don't wanna wrap it twice!
        try {
            if (func.__raven__) {
                return func;
            }

            // If this has already been wrapped in the past, return that
            if (func.__raven_wrapper__ ){
                return func.__raven_wrapper__ ;
            }
        } catch (e) {
            // Just accessing custom props in some Selenium environments
            // can cause a "Permission denied" exception (see raven-js#495).
            // Bail on wrapping and return the function as-is (defers to window.onerror).
            return func;
        }

        function wrapped() {
            var args = [], i = arguments.length,
                deep = !options || options && options.deep !== false;

            if (_before && isFunction(_before)) {
                _before.apply(this, arguments);
            }

            // Recursively wrap all of a function's arguments that are
            // functions themselves.
            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

            try {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means Raven caught an error invoking your application code. This is
                //       expected behavior and NOT indicative of a bug with Raven.js.
                return func.apply(this, args);
            } catch(e) {
                self._ignoreNextOnError();
                self.captureException(e, options);
                throw e;
            }
        }

        // copy over properties of the old function
        for (var property in func) {
            if (hasKey(func, property)) {
                wrapped[property] = func[property];
            }
        }
        wrapped.prototype = func.prototype;

        func.__raven_wrapper__ = wrapped;
        // Signal that this function has been wrapped already
        // for both debugging and to prevent it to being wrapped twice
        wrapped.__raven__ = true;
        wrapped.__inner__ = func;

        return wrapped;
    },

    /*
     * Uninstalls the global error handler.
     *
     * @return {Raven}
     */
    uninstall: function() {
        TraceKit.report.uninstall();

        this._restoreBuiltIns();

        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
        this._isRavenInstalled = false;

        return this;
    },

    /*
     * Manually capture an exception and send it over to Sentry
     *
     * @param {error} ex An exception to be logged
     * @param {object} options A specific set of options for this error [optional]
     * @return {Raven}
     */
    captureException: function(ex, options) {
        // If not an Error is passed through, recall as a message instead
        if (!isError(ex)) {
            return this.captureMessage(ex, objectMerge({
                trimHeadFrames: 1,
                stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
            }, options));
        }

        // Store the raw exception object for potential debugging and introspection
        this._lastCapturedException = ex;

        // TraceKit.report will re-raise any exception passed to it,
        // which means you have to wrap it in try/catch. Instead, we
        // can wrap it here and only re-raise if TraceKit.report
        // raises an exception different from the one we asked to
        // report on.
        try {
            var stack = TraceKit.computeStackTrace(ex);
            this._handleStackInfo(stack, options);
        } catch(ex1) {
            if(ex !== ex1) {
                throw ex1;
            }
        }

        return this;
    },

    /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
    captureMessage: function(msg, options) {
        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
        // early call; we'll error on the side of logging anything called before configuration since it's
        // probably something you should see:
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
            return;
        }

        options = options || {};

        var data = objectMerge({
            message: msg + ''  // Make sure it's actually a string
        }, options);

        if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
            var ex;
            // Generate a "synthetic" stack trace from this point.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
            //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
            //       or if it catches a thrown object without a "stack" property.
            try {
                throw new Error(msg);
            } catch (ex1) {
                ex = ex1;
            }

            // null exception name so `Error` isn't prefixed to msg
            ex.name = null;

            options = objectMerge({
                // fingerprint on msg, not stack trace (legacy behavior, could be
                // revisited)
                fingerprint: msg,
                // since we know this is a synthetic trace, the top N-most frames
                // MUST be from Raven.js, so mark them as in_app later by setting
                // trimHeadFrames
                trimHeadFrames: (options.trimHeadFrames || 0) + 1
            }, options);

            var stack = TraceKit.computeStackTrace(ex);
            var frames = this._prepareFrames(stack, options);
            data.stacktrace = {
                // Sentry expects frames oldest to newest
                frames: frames.reverse()
            }
        }

        // Fire away!
        this._send(data);

        return this;
    },

    captureBreadcrumb: function (obj) {
        var crumb = objectMerge({
            timestamp: now() / 1000
        }, obj);

        if (isFunction(this._globalOptions.breadcrumbCallback)) {
            var result = this._globalOptions.breadcrumbCallback(crumb);

            if (isObject(result) && !isEmptyObject(result)) {
                crumb = result;
            } else if (result === false) {
                return this;
            }
        }

        this._breadcrumbs.push(crumb);
        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
            this._breadcrumbs.shift();
        }
        return this;
    },

    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
        var pluginArgs = [].slice.call(arguments, 1);

        this._plugins.push([plugin, pluginArgs]);
        if (this._isRavenInstalled) {
            this._drainPlugins();
        }

        return this;
    },

    /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
    setUserContext: function(user) {
        // Intentionally do not merge here since that's an unexpected behavior.
        this._globalContext.user = user;

        return this;
    },

    /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
    setExtraContext: function(extra) {
        this._mergeContext('extra', extra);

        return this;
    },

    /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
    setTagsContext: function(tags) {
        this._mergeContext('tags', tags);

        return this;
    },

    /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
    clearContext: function() {
        this._globalContext = {};

        return this;
    },

    /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
    getContext: function() {
        // lol javascript
        return JSON.parse(stringify(this._globalContext));
    },


    /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
    setEnvironment: function(environment) {
        this._globalOptions.environment = environment;

        return this;
    },

    /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
    setRelease: function(release) {
        this._globalOptions.release = release;

        return this;
    },

    /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
    setDataCallback: function(callback) {
        var original = this._globalOptions.dataCallback;
        this._globalOptions.dataCallback =
          keepOriginalCallback(original, callback);
        return this;
    },

    /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
    setBreadcrumbCallback: function(callback) {
        var original = this._globalOptions.breadcrumbCallback;
        this._globalOptions.breadcrumbCallback =
          keepOriginalCallback(original, callback);
        return this;
    },

    /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
    setShouldSendCallback: function(callback) {
        var original = this._globalOptions.shouldSendCallback;
        this._globalOptions.shouldSendCallback =
          keepOriginalCallback(original, callback);
        return this;
    },

    /**
     * Override the default HTTP transport mechanism that transmits data
     * to the Sentry server.
     *
     * @param {function} transport Function invoked instead of the default
     *                             `makeRequest` handler.
     *
     * @return {Raven}
     */
    setTransport: function(transport) {
        this._globalOptions.transport = transport;

        return this;
    },

    /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
    lastException: function() {
        return this._lastCapturedException;
    },

    /*
     * Get the last event id
     *
     * @return {string}
     */
    lastEventId: function() {
        return this._lastEventId;
    },

    /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
    isSetup: function() {
        if (!this._hasJSON) return false;  // needs JSON support
        if (!this._globalServer) {
            if (!this.ravenNotConfiguredError) {
              this.ravenNotConfiguredError = true;
              this._logDebug('error', 'Error: Raven has not been configured.');
            }
            return false;
        }
        return true;
    },

    afterLoad: function () {
        // TODO: remove window dependence?

        // Attempt to initialize Raven on load
        var RavenConfig = _window.RavenConfig;
        if (RavenConfig) {
            this.config(RavenConfig.dsn, RavenConfig.config).install();
        }
    },

    showReportDialog: function (options) {
        if (!_document) // doesn't work without a document (React native)
            return;

        options = options || {};

        var lastEventId = options.eventId || this.lastEventId();
        if (!lastEventId) {
            throw new RavenConfigError('Missing eventId');
        }

        var dsn = options.dsn || this._dsn;
        if (!dsn) {
            throw new RavenConfigError('Missing DSN');
        }

        var encode = encodeURIComponent;
        var qs = '';
        qs += '?eventId=' + encode(lastEventId);
        qs += '&dsn=' + encode(dsn);

        var user = options.user || this._globalContext.user;
        if (user) {
            if (user.name)  qs += '&name=' + encode(user.name);
            if (user.email) qs += '&email=' + encode(user.email);
        }

        var globalServer = this._getGlobalServer(this._parseDSN(dsn));

        var script = _document.createElement('script');
        script.async = true;
        script.src = globalServer + '/api/embed/error-page/' + qs;
        (_document.head || _document.body).appendChild(script);
    },

    /**** Private functions ****/
    _ignoreNextOnError: function () {
        var self = this;
        this._ignoreOnError += 1;
        setTimeout(function () {
            // onerror should trigger before setTimeout
            self._ignoreOnError -= 1;
        });
    },

    _triggerEvent: function(eventType, options) {
        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
        var evt, key;

        if (!this._hasDocument)
            return;

        options = options || {};

        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);

        if (_document.createEvent) {
            evt = _document.createEvent('HTMLEvents');
            evt.initEvent(eventType, true, true);
        } else {
            evt = _document.createEventObject();
            evt.eventType = eventType;
        }

        for (key in options) if (hasKey(options, key)) {
            evt[key] = options[key];
        }

        if (_document.createEvent) {
            // IE9 if standards
            _document.dispatchEvent(evt);
        } else {
            // IE8 regardless of Quirks or Standards
            // IE9 if quirks
            try {
                _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
            } catch(e) {
                // Do nothing
            }
        }
    },

    /**
     * Wraps addEventListener to capture UI breadcrumbs
     * @param evtName the event name (e.g. "click")
     * @returns {Function}
     * @private
     */
    _breadcrumbEventHandler: function(evtName) {
        var self = this;
        return function (evt) {
            // reset keypress timeout; e.g. triggering a 'click' after
            // a 'keypress' will reset the keypress debounce so that a new
            // set of keypresses can be recorded
            self._keypressTimeout = null;

            // It's possible this handler might trigger multiple times for the same
            // event (e.g. event propagation through node ancestors). Ignore if we've
            // already captured the event.
            if (self._lastCapturedEvent === evt)
                return;

            self._lastCapturedEvent = evt;

            // try/catch both:
            // - accessing evt.target (see getsentry/raven-js#838, #768)
            // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
            //   can throw an exception in some circumstances.
            var target;
            try {
                target = htmlTreeAsString(evt.target);
            } catch (e) {
                target = '<unknown>';
            }

            self.captureBreadcrumb({
                category: 'ui.' + evtName, // e.g. ui.click, ui.input
                message: target
            });
        };
    },

    /**
     * Wraps addEventListener to capture keypress UI events
     * @returns {Function}
     * @private
     */
    _keypressEventHandler: function() {
        var self = this,
            debounceDuration = 1000; // milliseconds

        // TODO: if somehow user switches keypress target before
        //       debounce timeout is triggered, we will only capture
        //       a single breadcrumb from the FIRST target (acceptable?)
        return function (evt) {
            var target;
            try {
                target = evt.target;
            } catch (e) {
                // just accessing event properties can throw an exception in some rare circumstances
                // see: https://github.com/getsentry/raven-js/issues/838
                return;
            }
            var tagName = target && target.tagName;

            // only consider keypress events on actual input elements
            // this will disregard keypresses targeting body (e.g. tabbing
            // through elements, hotkeys, etc)
            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
                return;

            // record first keypress in a series, but ignore subsequent
            // keypresses until debounce clears
            var timeout = self._keypressTimeout;
            if (!timeout) {
                self._breadcrumbEventHandler('input')(evt);
            }
            clearTimeout(timeout);
            self._keypressTimeout = setTimeout(function () {
                self._keypressTimeout = null;
            }, debounceDuration);
        };
    },

    /**
     * Captures a breadcrumb of type "navigation", normalizing input URLs
     * @param to the originating URL
     * @param from the target URL
     * @private
     */
    _captureUrlChange: function(from, to) {
        var parsedLoc = parseUrl(this._location.href);
        var parsedTo = parseUrl(to);
        var parsedFrom = parseUrl(from);

        // because onpopstate only tells you the "new" (to) value of location.href, and
        // not the previous (from) value, we need to track the value of the current URL
        // state ourselves
        this._lastHref = to;

        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
            to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
            from = parsedFrom.relative;

        this.captureBreadcrumb({
            category: 'navigation',
            data: {
                to: to,
                from: from
            }
        });
    },

    /**
     * Wrap timer functions and event targets to catch errors and provide
     * better metadata.
     */
    _instrumentTryCatch: function() {
        var self = this;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapTimeFn(orig) {
            return function (fn, t) { // preserve arity
                // Make a copy of the arguments to prevent deoptimization
                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                var args = new Array(arguments.length);
                for(var i = 0; i < args.length; ++i) {
                    args[i] = arguments[i];
                }
                var originalCallback = args[0];
                if (isFunction(originalCallback)) {
                    args[0] = self.wrap(originalCallback);
                }

                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                // also supports only two arguments and doesn't care what this is, so we
                // can just call the original function directly.
                if (orig.apply) {
                    return orig.apply(this, args);
                } else {
                    return orig(args[0], args[1]);
                }
            };
        }

        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        function wrapEventTarget(global) {
            var proto = _window[global] && _window[global].prototype;
            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
                fill(proto, 'addEventListener', function(orig) {
                    return function (evtName, fn, capture, secure) { // preserve arity
                        try {
                            if (fn && fn.handleEvent) {
                                fn.handleEvent = self.wrap(fn.handleEvent);
                            }
                        } catch (err) {
                            // can sometimes get 'Permission denied to access property "handle Event'
                        }

                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                        // so that we don't have more than one wrapper function
                        var before,
                            clickHandler,
                            keypressHandler;

                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
                            // NOTE: generating multiple handlers per addEventListener invocation, should
                            //       revisit and verify we can just use one (almost certainly)
                            clickHandler = self._breadcrumbEventHandler('click');
                            keypressHandler = self._keypressEventHandler();
                            before = function (evt) {
                                // need to intercept every DOM event in `before` argument, in case that
                                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                                // see #724
                                if (!evt) return;

                                var eventType;
                                try {
                                    eventType = evt.type
                                } catch (e) {
                                    // just accessing event properties can throw an exception in some rare circumstances
                                    // see: https://github.com/getsentry/raven-js/issues/838
                                    return;
                                }
                                if (eventType === 'click')
                                    return clickHandler(evt);
                                else if (eventType === 'keypress')
                                    return keypressHandler(evt);
                            };
                        }
                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
                    };
                }, wrappedBuiltIns);
                fill(proto, 'removeEventListener', function (orig) {
                    return function (evt, fn, capture, secure) {
                        try {
                            fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
                        } catch (e) {
                            // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
                        }
                        return orig.call(this, evt, fn, capture, secure);
                    };
                }, wrappedBuiltIns);
            }
        }

        fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
        fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
        if (_window.requestAnimationFrame) {
            fill(_window, 'requestAnimationFrame', function (orig) {
                return function (cb) {
                    return orig(self.wrap(cb));
                };
            }, wrappedBuiltIns);
        }

        // event targets borrowed from bugsnag-js:
        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
        for (var i = 0; i < eventTargets.length; i++) {
            wrapEventTarget(eventTargets[i]);
        }
    },


    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - XMLHttpRequests
     *  - DOM interactions (click/typing)
     *  - window.location changes
     *  - console
     *
     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
     */
    _instrumentBreadcrumbs: function () {
        var self = this;
        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapProp(prop, xhr) {
            if (prop in xhr && isFunction(xhr[prop])) {
                fill(xhr, prop, function (orig) {
                    return self.wrap(orig);
                }); // intentionally don't track filled methods on XHR instances
            }
        }

        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
            var xhrproto = XMLHttpRequest.prototype;
            fill(xhrproto, 'open', function(origOpen) {
                return function (method, url) { // preserve arity

                    // if Sentry key appears in URL, don't capture
                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
                        this.__raven_xhr = {
                            method: method,
                            url: url,
                            status_code: null
                        };
                    }

                    return origOpen.apply(this, arguments);
                };
            }, wrappedBuiltIns);

            fill(xhrproto, 'send', function(origSend) {
                return function (data) { // preserve arity
                    var xhr = this;

                    function onreadystatechangeHandler() {
                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
                            try {
                                // touching statusCode in some platforms throws
                                // an exception
                                xhr.__raven_xhr.status_code = xhr.status;
                            } catch (e) { /* do nothing */ }
                            self.captureBreadcrumb({
                                type: 'http',
                                category: 'xhr',
                                data: xhr.__raven_xhr
                            });
                        }
                    }

                    var props = ['onload', 'onerror', 'onprogress'];
                    for (var j = 0; j < props.length; j++) {
                        wrapProp(props[j], xhr);
                    }

                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
                        fill(xhr, 'onreadystatechange', function (orig) {
                            return self.wrap(orig, undefined, onreadystatechangeHandler);
                        } /* intentionally don't track this instrumentation */);
                    } else {
                        // if onreadystatechange wasn't actually set by the page on this xhr, we
                        // are free to set our own and capture the breadcrumb
                        xhr.onreadystatechange = onreadystatechangeHandler;
                    }

                    return origSend.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.xhr && 'fetch' in _window) {
            fill(_window, 'fetch', function(origFetch) {
                return function (fn, t) { // preserve arity
                    // Make a copy of the arguments to prevent deoptimization
                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                    var args = new Array(arguments.length);
                    for (var i = 0; i < args.length; ++i) {
                        args[i] = arguments[i];
                    }

                    var fetchInput = args[0];
                    var method = 'GET';
                    var url;

                    if (typeof fetchInput === 'string') {
                        url = fetchInput;
                    } else {
                        url = fetchInput.url;
                        if (fetchInput.method) {
                            method = fetchInput.method;
                        }
                    }

                    if (args[1] && args[1].method) {
                        method = args[1].method;
                    }

                    var fetchData = {
                        method: method,
                        url: url,
                        status_code: null
                    };

                    self.captureBreadcrumb({
                        type: 'http',
                        category: 'fetch',
                        data: fetchData
                    });

                    return origFetch.apply(this, args).then(function (response) {
                        fetchData.status_code = response.status;

                        return response;
                    });
                };
            }, wrappedBuiltIns);
        }

        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        if (autoBreadcrumbs.dom && this._hasDocument) {
            if (_document.addEventListener) {
                _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
                _document.addEventListener('keypress', self._keypressEventHandler(), false);
            }
            else {
                // IE8 Compatibility
                _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
                _document.attachEvent('onkeypress', self._keypressEventHandler());
            }
        }

        // record navigation (URL) changes
        // NOTE: in Chrome App environment, touching history.pushState, *even inside
        //       a try/catch block*, will cause Chrome to output an error to console.error
        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
        var chrome = _window.chrome;
        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
        var hasPushState = !isChromePackagedApp && _window.history && history.pushState;
        if (autoBreadcrumbs.location && hasPushState) {
            // TODO: remove onpopstate handler on uninstall()
            var oldOnPopState = _window.onpopstate;
            _window.onpopstate = function () {
                var currentHref = self._location.href;
                self._captureUrlChange(self._lastHref, currentHref);

                if (oldOnPopState) {
                    return oldOnPopState.apply(this, arguments);
                }
            };

            fill(history, 'pushState', function (origPushState) {
                // note history.pushState.length is 0; intentionally not declaring
                // params to preserve 0 arity
                return function (/* state, title, url */) {
                    var url = arguments.length > 2 ? arguments[2] : undefined;

                    // url argument is optional
                    if (url) {
                        // coerce to string (this is what pushState does)
                        self._captureUrlChange(self._lastHref, url + '');
                    }

                    return origPushState.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.console && 'console' in _window && console.log) {
            // console
            var consoleMethodCallback = function (msg, data) {
                self.captureBreadcrumb({
                    message: msg,
                    level: data.level,
                    category: 'console'
                });
            };

            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
                wrapConsoleMethod(console, level, consoleMethodCallback);
            });
        }

    },

    _restoreBuiltIns: function () {
        // restore any wrapped builtins
        var builtin;
        while (this._wrappedBuiltIns.length) {
            builtin = this._wrappedBuiltIns.shift();

            var obj = builtin[0],
              name = builtin[1],
              orig = builtin[2];

            obj[name] = orig;
        }
    },

    _drainPlugins: function() {
        var self = this;

        // FIX ME TODO
        each(this._plugins, function(_, plugin) {
            var installer = plugin[0];
            var args = plugin[1];
            installer.apply(self, [self].concat(args));
        });
    },

    _parseDSN: function(str) {
        var m = dsnPattern.exec(str),
            dsn = {},
            i = 7;

        try {
            while (i--) dsn[dsnKeys[i]] = m[i] || '';
        } catch(e) {
            throw new RavenConfigError('Invalid DSN: ' + str);
        }

        if (dsn.pass && !this._globalOptions.allowSecretKey) {
            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
        }

        return dsn;
    },

    _getGlobalServer: function(uri) {
        // assemble the endpoint from the uri pieces
        var globalServer = '//' + uri.host +
            (uri.port ? ':' + uri.port : '');

        if (uri.protocol) {
            globalServer = uri.protocol + ':' + globalServer;
        }
        return globalServer;
    },

    _handleOnErrorStackInfo: function() {
        // if we are intentionally ignoring errors via onerror, bail out
        if (!this._ignoreOnError) {
            this._handleStackInfo.apply(this, arguments);
        }
    },

    _handleStackInfo: function(stackInfo, options) {
        var frames = this._prepareFrames(stackInfo, options);

        this._triggerEvent('handle', {
            stackInfo: stackInfo,
            options: options
        });

        this._processException(
            stackInfo.name,
            stackInfo.message,
            stackInfo.url,
            stackInfo.lineno,
            frames,
            options
        );
    },

    _prepareFrames: function(stackInfo, options) {
        var self = this;
        var frames = [];
        if (stackInfo.stack && stackInfo.stack.length) {
            each(stackInfo.stack, function(i, stack) {
                var frame = self._normalizeFrame(stack);
                if (frame) {
                    frames.push(frame);
                }
            });

            // e.g. frames captured via captureMessage throw
            if (options && options.trimHeadFrames) {
                for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
                    frames[j].in_app = false;
                }
            }
        }
        frames = frames.slice(0, this._globalOptions.stackTraceLimit);
        return frames;
    },


    _normalizeFrame: function(frame) {
        if (!frame.url) return;

        // normalize the frames data
        var normalized = {
            filename:   frame.url,
            lineno:     frame.line,
            colno:      frame.column,
            'function': frame.func || '?'
        };

        normalized.in_app = !( // determine if an exception came from outside of our app
            // first we check the global includePaths list.
            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
            // Now we check for fun, if the function name is Raven or TraceKit
            /(Raven|TraceKit)\./.test(normalized['function']) ||
            // finally, we do a last ditch effort and check for raven.min.js
            /raven\.(min\.)?js$/.test(normalized.filename)
        );

        return normalized;
    },

    _processException: function(type, message, fileurl, lineno, frames, options) {
        var stacktrace;
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;

        message += '';

        if (frames && frames.length) {
            fileurl = frames[0].filename || fileurl;
            // Sentry expects frames oldest to newest
            // and JS sends them as newest to oldest
            frames.reverse();
            stacktrace = {frames: frames};
        } else if (fileurl) {
            stacktrace = {
                frames: [{
                    filename: fileurl,
                    lineno: lineno,
                    in_app: true
                }]
            };
        }

        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;

        var data = objectMerge({
            // sentry.interfaces.Exception
            exception: {
                values: [{
                    type: type,
                    value: message,
                    stacktrace: stacktrace
                }]
            },
            culprit: fileurl
        }, options);

        // Fire away!
        this._send(data);
    },

    _trimPacket: function(data) {
        // For now, we only want to truncate the two different messages
        // but this could/should be expanded to just trim everything
        var max = this._globalOptions.maxMessageLength;
        if (data.message) {
            data.message = truncate(data.message, max);
        }
        if (data.exception) {
            var exception = data.exception.values[0];
            exception.value = truncate(exception.value, max);
        }

        var request = data.request;
        if (request) {
            if (request.url) {
                request.url = truncate(request.url, this._globalOptions.maxUrlLength);
            }
            if (request.Referer) {
                request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
            }
        }

        if (data.breadcrumbs && data.breadcrumbs.values)
            this._trimBreadcrumbs(data.breadcrumbs);

        return data;
    },

    /**
     * Truncate breadcrumb values (right now just URLs)
     */
    _trimBreadcrumbs: function (breadcrumbs) {
        // known breadcrumb properties with urls
        // TODO: also consider arbitrary prop values that start with (https?)?://
        var urlProps = ['to', 'from', 'url'],
            urlProp,
            crumb,
            data;

        for (var i = 0; i < breadcrumbs.values.length; ++i) {
            crumb = breadcrumbs.values[i];
            if (!crumb.hasOwnProperty('data') || !isObject(crumb.data) || objectFrozen(crumb.data))
                continue;

            data = objectMerge({}, crumb.data);
            for (var j = 0; j < urlProps.length; ++j) {
                urlProp = urlProps[j];
                if (data.hasOwnProperty(urlProp)) {
                    data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
                }
            }
            breadcrumbs.values[i].data = data;
        }
    },

    _getHttpData: function() {
        if (!this._hasNavigator && !this._hasDocument) return;
        var httpData = {};

        if (this._hasNavigator && _navigator.userAgent) {
            httpData.headers = {
              'User-Agent': navigator.userAgent
            };
        }

        if (this._hasDocument) {
            if (_document.location && _document.location.href) {
                httpData.url = _document.location.href;
            }
            if (_document.referrer) {
                if (!httpData.headers) httpData.headers = {};
                httpData.headers.Referer = _document.referrer;
            }
        }

        return httpData;
    },

    _resetBackoff: function() {
        this._backoffDuration = 0;
        this._backoffStart = null;
    },

    _shouldBackoff: function() {
        return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
    },

    /**
     * Returns true if the in-process data payload matches the signature
     * of the previously-sent data
     *
     * NOTE: This has to be done at this level because TraceKit can generate
     *       data from window.onerror WITHOUT an exception object (IE8, IE9,
     *       other old browsers). This can take the form of an "exception"
     *       data object with a single frame (derived from the onerror args).
     */
    _isRepeatData: function (current) {
        var last = this._lastData;

        if (!last ||
            current.message !== last.message || // defined for captureMessage
            current.culprit !== last.culprit)   // defined for captureException/onerror
            return false;

        // Stacktrace interface (i.e. from captureMessage)
        if (current.stacktrace || last.stacktrace) {
            return isSameStacktrace(current.stacktrace, last.stacktrace);
        }
        // Exception interface (i.e. from captureException/onerror)
        else if (current.exception || last.exception) {
            return isSameException(current.exception, last.exception);
        }

        return true;
    },

    _setBackoffState: function(request) {
        // If we are already in a backoff state, don't change anything
        if (this._shouldBackoff()) {
            return;
        }

        var status = request.status;

        // 400 - project_id doesn't exist or some other fatal
        // 401 - invalid/revoked dsn
        // 429 - too many requests
        if (!(status === 400 || status === 401 || status === 429))
            return;

        var retry;
        try {
            // If Retry-After is not in Access-Control-Expose-Headers, most
            // browsers will throw an exception trying to access it
            retry = request.getResponseHeader('Retry-After');
            retry = parseInt(retry, 10) * 1000; // Retry-After is returned in seconds
        } catch (e) {
            /* eslint no-empty:0 */
        }


        this._backoffDuration = retry
            // If Sentry server returned a Retry-After value, use it
            ? retry
            // Otherwise, double the last backoff duration (starts at 1 sec)
            : this._backoffDuration * 2 || 1000;

        this._backoffStart = now();
    },

    _send: function(data) {
        var globalOptions = this._globalOptions;

        var baseData = {
            project: this._globalProject,
            logger: globalOptions.logger,
            platform: 'javascript'
        }, httpData = this._getHttpData();

        if (httpData) {
            baseData.request = httpData;
        }

        // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
        if (data.trimHeadFrames) delete data.trimHeadFrames;

        data = objectMerge(baseData, data);

        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

        // Send along our own collected metadata with extra
        data.extra['session:duration'] = now() - this._startTime;

        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
            // intentionally make shallow copy so that additions
            // to breadcrumbs aren't accidentally sent in this request
            data.breadcrumbs = {
                values: [].slice.call(this._breadcrumbs, 0)
            };
        }

        // If there are no tags/extra, strip the key from the payload alltogther.
        if (isEmptyObject(data.tags)) delete data.tags;

        if (this._globalContext.user) {
            // sentry.interfaces.User
            data.user = this._globalContext.user;
        }

        // Include the environment if it's defined in globalOptions
        if (globalOptions.environment) data.environment = globalOptions.environment;

        // Include the release if it's defined in globalOptions
        if (globalOptions.release) data.release = globalOptions.release;

        // Include server_name if it's defined in globalOptions
        if (globalOptions.serverName) data.server_name = globalOptions.serverName;

        if (isFunction(globalOptions.dataCallback)) {
            data = globalOptions.dataCallback(data) || data;
        }

        // Why??????????
        if (!data || isEmptyObject(data)) {
            return;
        }

        // Check if the request should be filtered or not
        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
            return;
        }

        // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
        // so drop requests until "cool-off" period has elapsed.
        if (this._shouldBackoff()) {
            this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
            return;
        }

        if (typeof globalOptions.sampleRate === 'number') {
            if (Math.random() < globalOptions.sampleRate) {
                this._sendProcessedPayload(data);
            }
        } else {
            this._sendProcessedPayload(data);
        }
    },

    _getUuid: function () {
      return uuid4();
    },

    _sendProcessedPayload: function(data, callback) {
        var self = this;
        var globalOptions = this._globalOptions;

        if (!this.isSetup()) return;

        // Send along an event_id if not explicitly passed.
        // This event_id can be used to reference the error within Sentry itself.
        // Set lastEventId after we know the error should actually be sent
        this._lastEventId = data.event_id || (data.event_id = this._getUuid());

        // Try and clean up the packet before sending by truncating long values
        data = this._trimPacket(data);

        // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
        // but this would require copying an un-truncated copy of the data packet, which can be
        // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
        if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
            this._logDebug('warn', 'Raven dropped repeat event: ', data);
            return;
        }

        // Store outbound payload after trim
        this._lastData = data;

        this._logDebug('debug', 'Raven about to send:', data);

        var auth = {
            sentry_version: '7',
            sentry_client: 'raven-js/' + this.VERSION,
            sentry_key: this._globalKey
        };
        if (this._globalSecret) {
            auth.sentry_secret = this._globalSecret;
        }

        var exception = data.exception && data.exception.values[0];
        this.captureBreadcrumb({
            category: 'sentry',
            message: exception
                ? (exception.type ? exception.type + ': ' : '') + exception.value
                : data.message,
            event_id: data.event_id,
            level: data.level || 'error' // presume error unless specified
        });

        var url = this._globalEndpoint;
        (globalOptions.transport || this._makeRequest).call(this, {
            url: url,
            auth: auth,
            data: data,
            options: globalOptions,
            onSuccess: function success() {
                self._resetBackoff();

                self._triggerEvent('success', {
                    data: data,
                    src: url
                });
                callback && callback();
            },
            onError: function failure(error) {
                self._logDebug('error', 'Raven transport failed to send: ', error);

                if (error.request) {
                    self._setBackoffState(error.request);
                }

                self._triggerEvent('failure', {
                    data: data,
                    src: url
                });
                error = error || new Error('Raven send failed (no additional details provided)');
                callback && callback(error);
            }
        });
    },

    _makeRequest: function(opts) {
        var request = new XMLHttpRequest();

        // if browser doesn't support CORS (e.g. IE7), we are out of luck
        var hasCORS =
            'withCredentials' in request ||
            typeof XDomainRequest !== 'undefined';

        if (!hasCORS) return;

        var url = opts.url;

        if ('withCredentials' in request) {
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                } else if (request.status === 200) {
                    opts.onSuccess && opts.onSuccess();
                } else if (opts.onError) {
                    var err = new Error('Sentry error code: ' + request.status);
                    err.request = request;
                    opts.onError(err);
                }
            };
        } else {
            request = new XDomainRequest();
            // xdomainrequest cannot go http -> https (or vice versa),
            // so always use protocol relative
            url = url.replace(/^https?:/, '');

            // onreadystatechange not supported by XDomainRequest
            if (opts.onSuccess) {
                request.onload = opts.onSuccess;
            }
            if (opts.onError) {
                request.onerror = function () {
                    var err = new Error('Sentry error code: XDomainRequest');
                    err.request = request;
                    opts.onError(err);
                }
            }
        }

        // NOTE: auth is intentionally sent as part of query string (NOT as custom
        //       HTTP header) so as to avoid preflight CORS requests
        request.open('POST', url + '?' + urlencode(opts.auth));
        request.send(stringify(opts.data));
    },

    _logDebug: function(level) {
        if (this._originalConsoleMethods[level] && this.debug) {
            // In IE<10 console methods do not have their own 'apply' method
            Function.prototype.apply.call(
                this._originalConsoleMethods[level],
                this._originalConsole,
                [].slice.call(arguments, 1)
            );
        }
    },

    _mergeContext: function(key, context) {
        if (isUndefined(context)) {
            delete this._globalContext[key];
        } else {
            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
        }
    }
};

/*------------------------------------------------
 * utils
 *
 * conditionally exported for test via Raven.utils
 =================================================
 */
var objectPrototype = Object.prototype;

function isUndefined(what) {
    return what === void 0;
}

function isFunction(what) {
    return typeof what === 'function';
}

function isString(what) {
    return objectPrototype.toString.call(what) === '[object String]';
}


function isEmptyObject(what) {
    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
    return true;
}

function each(obj, callback) {
    var i, j;

    if (isUndefined(obj.length)) {
        for (i in obj) {
            if (hasKey(obj, i)) {
                callback.call(null, i, obj[i]);
            }
        }
    } else {
        j = obj.length;
        if (j) {
            for (i = 0; i < j; i++) {
                callback.call(null, i, obj[i]);
            }
        }
    }
}

function objectMerge(obj1, obj2) {
    if (!obj2) {
        return obj1;
    }
    each(obj2, function(key, value){
        obj1[key] = value;
    });
    return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
    if (!Object.isFrozen) {
        return false;
    }
    return Object.isFrozen(obj);
}

function truncate(str, max) {
    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
    return objectPrototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
    // Combine an array of regular expressions and strings into one large regexp
    // Be mad.
    var sources = [],
        i = 0, len = patterns.length,
        pattern;

    for (; i < len; i++) {
        pattern = patterns[i];
        if (isString(pattern)) {
            // If it's a string, we need to escape it
            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
        } else if (pattern && pattern.source) {
            // If it's a regexp already, we want to extract the source
            sources.push(pattern.source);
        }
        // Intentionally skip other cases
    }
    return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
    var pairs = [];
    each(o, function(key, value) {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};

    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        protocol: match[2],
        host: match[4],
        path: match[5],
        relative: match[5] + query + fragment // everything minus origin
    };
}
function uuid4() {
    var crypto = _window.crypto || _window.msCrypto;

    if (!isUndefined(crypto) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);

        // set 4 in byte 7
        arr[3] = arr[3] & 0xFFF | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        arr[4] = arr[4] & 0x3FFF | 0x8000;

        var pad = function(num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = '0' + v;
            }
            return v;
        };

        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    } else {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0,
                v = c === 'x' ? r : r&0x3|0x8;
            return v.toString(16);
        });
    }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
    /* eslint no-extra-parens:0*/
    var MAX_TRAVERSE_HEIGHT = 5,
        MAX_OUTPUT_LEN = 80,
        out = [],
        height = 0,
        len = 0,
        separator = ' > ',
        sepLength = separator.length,
        nextStr;

    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {

        nextStr = htmlElementAsString(elem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
            break;
        }

        out.push(nextStr);

        len += nextStr.length;
        elem = elem.parentNode;
    }

    return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
    var out = [],
        className,
        classes,
        key,
        attr,
        i;

    if (!elem || !elem.tagName) {
        return '';
    }

    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push('#' + elem.id);
    }

    className = elem.className;
    if (className && isString(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push('.' + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push('[' + key + '="' + attr + '"]');
        }
    }
    return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
    return !!(!!a ^ !!b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
    if (isOnlyOneTruthy(ex1, ex2))
        return false;

    ex1 = ex1.values[0];
    ex2 = ex2.values[0];

    if (ex1.type !== ex2.type ||
        ex1.value !== ex2.value)
        return false;

    return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
    if (isOnlyOneTruthy(stack1, stack2))
        return false;

    var frames1 = stack1.frames;
    var frames2 = stack2.frames;

    // Exit early if frame count differs
    if (frames1.length !== frames2.length)
        return false;

    // Iterate through every frame; bail out if anything differs
    var a, b;
    for (var i = 0; i < frames1.length; i++) {
        a = frames1[i];
        b = frames2[i];
        if (a.filename !== b.filename ||
            a.lineno !== b.lineno ||
            a.colno !== b.colno ||
            a['function'] !== b['function'])
            return false;
    }
    return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
    var orig = obj[name];
    obj[name] = replacement(orig);
    if (track) {
        track.push([obj, name, orig]);
    }
}

if (typeof __DEV__ !== 'undefined' && __DEV__) {
    Raven.utils = {
        isUndefined: isUndefined,
        isFunction: isFunction,
        isString: isString,
        isObject: isObject,
        isEmptyObject: isEmptyObject,
        isError: isError,
        each: each,
        objectMerge: objectMerge,
        truncate: truncate,
        hasKey: hasKey,
        joinRegExp: joinRegExp,
        urlencode: urlencode,
        uuid4: uuid4,
        htmlTreeAsString: htmlTreeAsString,
        htmlElementAsString: htmlElementAsString,
        parseUrl: parseUrl,
        fill: fill
    };
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var utils = __webpack_require__(17);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
    collectWindowErrors: true,
    debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
    if (typeof document === 'undefined' || typeof document.location === 'undefined')
        return '';

    return document.location.href;
}


/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
    var handlers = [],
        lastArgs = null,
        lastException = null,
        lastExceptionStack = null;

    /**
     * Add a crash handler.
     * @param {Function} handler
     */
    function subscribe(handler) {
        installGlobalHandler();
        handlers.push(handler);
    }

    /**
     * Remove a crash handler.
     * @param {Function} handler
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; --i) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
    }

    /**
     * Remove all crash handlers.
     */
    function unsubscribeAll() {
        uninstallGlobalHandler();
        handlers = [];
    }

    /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
    function notifyHandlers(stack, isWindowError) {
        var exception = null;
        if (isWindowError && !TraceKit.collectWindowErrors) {
          return;
        }
        for (var i in handlers) {
            if (handlers.hasOwnProperty(i)) {
                try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                } catch (inner) {
                    exception = inner;
                }
            }
        }

        if (exception) {
            throw exception;
        }
    }

    var _oldOnerrorHandler, _onErrorHandlerInstalled;

    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     * @param {?(number|string)} colNo The column number at which the error
     * occurred.
     * @param {?Error} ex The actual Error object.
     */
    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
        var stack = null;

        if (lastExceptionStack) {
            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
            processLastException();
        } else if (ex && utils.isError(ex)) {
            // non-string `ex` arg; attempt to extract stack trace

            // New chrome and blink send along a real error object
            // Let's just report that like a normal error.
            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
            stack = TraceKit.computeStackTrace(ex);
            notifyHandlers(stack, true);
        } else {
            var location = {
                'url': url,
                'line': lineNo,
                'column': colNo
            };

            var name = undefined;
            var msg = message; // must be new var or will modify original `arguments`
            var groups;
            if ({}.toString.call(message) === '[object String]') {
                var groups = message.match(ERROR_TYPES_RE);
                if (groups) {
                    name = groups[1];
                    msg = groups[2];
                }
            }

            location.func = UNKNOWN_FUNCTION;

            stack = {
                'name': name,
                'message': msg,
                'url': getLocationHref(),
                'stack': [location]
            };
            notifyHandlers(stack, true);
        }

        if (_oldOnerrorHandler) {
            return _oldOnerrorHandler.apply(this, arguments);
        }

        return false;
    }

    function installGlobalHandler ()
    {
        if (_onErrorHandlerInstalled) {
            return;
        }
        _oldOnerrorHandler = _window.onerror;
        _window.onerror = traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }

    function uninstallGlobalHandler ()
    {
        if (!_onErrorHandlerInstalled) {
            return;
        }
        _window.onerror = _oldOnerrorHandler;
        _onErrorHandlerInstalled = false;
        _oldOnerrorHandler = undefined;
    }

    function processLastException() {
        var _lastExceptionStack = lastExceptionStack,
            _lastArgs = lastArgs;
        lastArgs = null;
        lastExceptionStack = null;
        lastException = null;
        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
    }

    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @param {?boolean} rethrow If false, do not re-throw the exception.
     * Only used for window.onerror to not cause an infinite loop of
     * rethrowing.
     */
    function report(ex, rethrow) {
        var args = _slice.call(arguments, 1);
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            } else {
              processLastException();
            }
        }

        var stack = TraceKit.computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        lastArgs = args;

        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, (stack.incomplete ? 2000 : 0));

        if (rethrow !== false) {
            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
        }
    }

    report.subscribe = subscribe;
    report.unsubscribe = unsubscribe;
    report.uninstall = unsubscribeAll;
    return report;
}());

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStackProp(ex) {
        if (typeof ex.stack === 'undefined' || !ex.stack) return;

        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,
            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,

            // Used to additionally parse URL/line/column from eval frames
            geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
            chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/,

            lines = ex.stack.split('\n'),
            stack = [],
            submatch,
            parts,
            element,
            reference = /^(.*) is undefined$/.exec(ex.message);

        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = chrome.exec(lines[i]))) {
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    parts[3] = submatch[2]; // line
                    parts[4] = submatch[3]; // column
                }
                element = {
                    'url': !isNative ? parts[2] : null,
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': isNative ? [parts[2]] : [],
                    'line': parts[3] ? +parts[3] : null,
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ( parts = winjs.exec(lines[i]) ) {
                element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': [],
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ((parts = gecko.exec(lines[i]))) {
                var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                    // throw out eval line/column and use top-most line number
                    parts[3] = submatch[1];
                    parts[4] = submatch[2];
                    parts[5] = null; // no column when eval
                } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
                    // FireFox uses this awesome columnNumber property for its top frame
                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                    // so adding 1
                    // NOTE: this hack doesn't work if top-most frame is eval
                    stack[0].column = ex.columnNumber + 1;
                }
                element = {
                    'url': parts[3],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': parts[2] ? parts[2].split(',') : [],
                    'line': parts[4] ? +parts[4] : null,
                    'column': parts[5] ? +parts[5] : null
                };
            } else {
                continue;
            }

            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }

            stack.push(element);
        }

        if (!stack.length) {
            return null;
        }

        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
    }

    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            'url': url,
            'line': lineNo
        };

        if (initial.url && initial.line) {
            stackInfo.incomplete = false;

            if (!initial.func) {
                initial.func = UNKNOWN_FUNCTION;
            }

            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        return false;
                    }
                }
            }

            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        } else {
            stackInfo.incomplete = true;
        }

        return false;
    }

    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
            stack = [],
            funcs = {},
            recursion = false,
            parts,
            item,
            source;

        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === TraceKit.report) {
                // console.log('skipping internal function');
                continue;
            }

            item = {
                'url': null,
                'func': UNKNOWN_FUNCTION,
                'line': null,
                'column': null
            };

            if (curr.name) {
                item.func = curr.name;
            } else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }

            if (typeof item.func === 'undefined') {
              try {
                item.func = parts.input.substring(0, parts.input.indexOf('{'));
              } catch (e) { }
            }

            if (funcs['' + curr]) {
                recursion = true;
            }else{
                funcs['' + curr] = true;
            }

            stack.push(item);
        }

        if (depth) {
            // console.log('depth is ' + depth);
            // console.log('stack is ' + stack.length);
            stack.splice(0, depth);
        }

        var result = {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }

    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = (depth == null ? 0 : +depth);

        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }

        try {
            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }
        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref()
        };
    }

    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

    return computeStackTrace;
}());

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified for IE8 compatibility.
 Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify
exports.getSerialize = serializer

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return '[Circular ~]'
    return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']'
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~indexOf(stack, value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function RavenConfigError(message) {
    this.name = 'RavenConfigError';
    this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wrapMethod = function(console, level, callback) {
    var originalConsoleLevel = console[level];
    var originalConsole = console;

    if (!(level in console)) {
        return;
    }

    var sentryLevel = level === 'warn'
        ? 'warning'
        : level;

    console[level] = function () {
        var args = [].slice.call(arguments);

        var msg = '' + args.join(' ');
        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
        callback && callback(msg, data);

        // this fails for some browsers. :(
        if (originalConsoleLevel) {
            // IE9 doesn't allow calling apply on console functions directly
            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
            Function.prototype.apply.call(
                originalConsoleLevel,
                originalConsole,
                args
            );
        }
    };
};

module.exports = {
    wrapMethod: wrapMethod
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.13
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.13",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName){
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			if (split[5]) {
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2017b",
	"zones": [
		"America/Adak|HST HDT|a0 90|01010101010101010101010|1GIc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326",
		"America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1GIb0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4",
		"America/Denver|MST MDT|70 60|01010101010101010101010|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5",
		"America/Chicago|CST CDT|60 50|01010101010101010101010|1GI80 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5",
		"America/Phoenix|MST|70|0||42e5",
		"America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6",
		"America/New_York|EST EDT|50 40|01010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6",
		"America/Metlakatla|PST AKST AKDT|80 90 80|0121212121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2",
		"Pacific/Honolulu|HST|a0|0||37e4"
	],
	"links": [
		"America/Adak|America/Atka",
		"America/Adak|US/Aleutian",
		"America/Anchorage|America/Juneau",
		"America/Anchorage|America/Nome",
		"America/Anchorage|America/Sitka",
		"America/Anchorage|America/Yakutat",
		"America/Anchorage|US/Alaska",
		"America/Chicago|America/Indiana/Knox",
		"America/Chicago|America/Indiana/Tell_City",
		"America/Chicago|America/Knox_IN",
		"America/Chicago|America/Matamoros",
		"America/Chicago|America/Menominee",
		"America/Chicago|America/North_Dakota/Beulah",
		"America/Chicago|America/North_Dakota/Center",
		"America/Chicago|America/North_Dakota/New_Salem",
		"America/Chicago|America/Rainy_River",
		"America/Chicago|America/Rankin_Inlet",
		"America/Chicago|America/Resolute",
		"America/Chicago|America/Winnipeg",
		"America/Chicago|CST6CDT",
		"America/Chicago|Canada/Central",
		"America/Chicago|US/Central",
		"America/Chicago|US/Indiana-Starke",
		"America/Denver|America/Boise",
		"America/Denver|America/Cambridge_Bay",
		"America/Denver|America/Edmonton",
		"America/Denver|America/Inuvik",
		"America/Denver|America/Ojinaga",
		"America/Denver|America/Shiprock",
		"America/Denver|America/Yellowknife",
		"America/Denver|Canada/Mountain",
		"America/Denver|MST7MDT",
		"America/Denver|Navajo",
		"America/Denver|US/Mountain",
		"America/Los_Angeles|America/Dawson",
		"America/Los_Angeles|America/Ensenada",
		"America/Los_Angeles|America/Santa_Isabel",
		"America/Los_Angeles|America/Tijuana",
		"America/Los_Angeles|America/Vancouver",
		"America/Los_Angeles|America/Whitehorse",
		"America/Los_Angeles|Canada/Pacific",
		"America/Los_Angeles|Canada/Yukon",
		"America/Los_Angeles|Mexico/BajaNorte",
		"America/Los_Angeles|PST8PDT",
		"America/Los_Angeles|US/Pacific",
		"America/Los_Angeles|US/Pacific-New",
		"America/New_York|America/Detroit",
		"America/New_York|America/Fort_Wayne",
		"America/New_York|America/Indiana/Indianapolis",
		"America/New_York|America/Indiana/Marengo",
		"America/New_York|America/Indiana/Petersburg",
		"America/New_York|America/Indiana/Vevay",
		"America/New_York|America/Indiana/Vincennes",
		"America/New_York|America/Indiana/Winamac",
		"America/New_York|America/Indianapolis",
		"America/New_York|America/Iqaluit",
		"America/New_York|America/Kentucky/Louisville",
		"America/New_York|America/Kentucky/Monticello",
		"America/New_York|America/Louisville",
		"America/New_York|America/Montreal",
		"America/New_York|America/Nassau",
		"America/New_York|America/Nipigon",
		"America/New_York|America/Pangnirtung",
		"America/New_York|America/Thunder_Bay",
		"America/New_York|America/Toronto",
		"America/New_York|Canada/Eastern",
		"America/New_York|EST5EDT",
		"America/New_York|US/East-Indiana",
		"America/New_York|US/Eastern",
		"America/New_York|US/Michigan",
		"America/Phoenix|America/Creston",
		"America/Phoenix|America/Dawson_Creek",
		"America/Phoenix|America/Hermosillo",
		"America/Phoenix|MST",
		"America/Phoenix|US/Arizona",
		"Pacific/Honolulu|HST",
		"Pacific/Honolulu|Pacific/Johnston",
		"Pacific/Honolulu|US/Hawaii"
	]
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(36);
var bytesToUuid = __webpack_require__(37);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"attrs":{"id":"widget-styles"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./openchair.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./openchair.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 39 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = {
  practiceName: null,
  bookings: [],
  locations: [],
  timezone: null,
  currentLocation: {
    location: null,
    bookings: []
  },
  currentDay: null,
  patientInfo: null,
  appointmentInfo: null,
  calendarStart: null,
  calendarEnd: null,
  loadedUntil: null,
  orthoConfirm: null
};

exports.default = data;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ravenJs = __webpack_require__(3);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _domHelpers = __webpack_require__(1);

var _widgetController = __webpack_require__(0);

var _widgetButton = __webpack_require__(42);

var _widgetButton2 = _interopRequireDefault(_widgetButton);

var _widgetModal = __webpack_require__(10);

var _widgetModal2 = _interopRequireDefault(_widgetModal);

var _setColors = __webpack_require__(11);

var _widgetModal3 = __webpack_require__(13);

var _widgetModal4 = _interopRequireDefault(_widgetModal3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: ony stops body scrolling on desktop.
// To enable scrolling, uncomment position:fixed on noscroll class in widetmodal.css media query.
// Comes at a cost of not being able to hide url and botttom bar anymore (that's way not doing it)
var toggleScroll = function () {
  var scrollAmount = void 0;
  return function (on) {
    if (on) {
      (0, _domHelpers.removeClass)(document.body, _widgetModal4.default.noscroll);
      window.scrollTo(0, scrollAmount);
    } else {
      scrollAmount = document.body.scrollTop;
      document.body.className += ' ' + _widgetModal4.default.noscroll;
    }
  };
}(); // args: element to hide, element to show


var widget = {
  init: function init(widgetDiv) {
    this.hideMainButton = (0, _setColors.hideMainButton)();
    this.widgetModalElem = _widgetModal2.default.init();
    this.widgetButtonElem = _widgetButton2.default.init();

    if (this.hideMainButton) {
      widgetDiv.append(this.widgetModalElem);
    } else {
      this.widgetButtonElem.addEventListener('click', this.onOpenModalClick.bind(this));
      widgetDiv.append(this.widgetButtonElem, this.widgetModalElem);
    }

    document.addEventListener('click', this.onCloseModalClick.bind(this));

    if (window.location.hash === '#/schedule-consultation') {
      _widgetModal2.default.render();
      (0, _domHelpers.toggle)(this.widgetButtonElem, this.widgetModalElem);
    }

    document.body.addEventListener('click', this.externalClick.bind(this));
  },
  onOpenModalClick: function onOpenModalClick() {
    var _this = this;

    // report to google analytics
    if (true) {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Button',
        eventAction: 'openModal'
      });
    }

    _widgetController.widgetCtrl.refreshBookings().then(function () {
      _widgetModal2.default.render();
      // update the bookings array with fresh data
      (0, _domHelpers.toggle)(_this.widgetButtonElem, _this.widgetModalElem, 'block');
      // needed to show the map:
      window.dispatchEvent(new Event('resize'));

      // disable scrolling when modal is open:
      toggleScroll(false);
    }).catch(function (err) {
      _ravenJs2.default.captureException(err);
    });
  },
  externalClick: function externalClick(event) {
    var classList = Array.from(event.target.classList);
    if (classList.includes('openchair-widget')) {
      this.onOpenModalClick();
    }
  },
  onCloseModalClick: function onCloseModalClick(event) {
    if (event.target === this.widgetModalElem || event.target.className === _widgetModal4.default.closeBtn) {
      // update indicator values:

      _widgetButton2.default.render();
      (0, _domHelpers.toggle)(this.widgetModalElem, this.widgetButtonElem);

      // enable body scrolling when the modal is closed
      toggleScroll(true);
    }
  },
  handleError: function handleError(errorText) {
    _widgetModal2.default.showError(errorText);
  },
  render: function render() {
    _widgetModal2.default.render();
    _widgetButton2.default.render();
  }
};

exports.default = widget;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _momentTimezone = __webpack_require__(6);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _widgetButton = __webpack_require__(43);

var _widgetButton2 = _interopRequireDefault(_widgetButton);

var _domHelpers = __webpack_require__(1);

var _analytics = __webpack_require__(7);

var _widgetController = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetButton = {
  init: function init() {
    var _this = this;

    // /////////////
    // / Elements ///
    // //////////////

    this.buttonContainer = (0, _domHelpers.createBtn)(_widgetButton2.default.container + ' open-chair-widget___button');

    this.icon = (0, _domHelpers.createEl)('img', _widgetButton2.default.icon, '', { src: __webpack_require__(45) });
    this.indicator = (0, _domHelpers.createEl)('div', _widgetButton2.default.indicatorDot);
    this.button = (0, _domHelpers.createEl)('div', _widgetButton2.default.button);
    this.button.append(this.indicator, this.icon);

    this.buttonExpand = (0, _domHelpers.createEl)('div', _widgetButton2.default.expand);
    this.indicatorText = (0, _domHelpers.createEl)('span', _widgetButton2.default.indicatorText, '');
    this.buttonText = (0, _domHelpers.createEl)('span', _widgetButton2.default.mainText, 'Schedule Consultation');
    this.buttonExpand.append(this.indicatorText, this.buttonText);
    this.buttonContainer.append(this.buttonExpand, this.button);

    // TODO: test/adjust on mobile/add touch events - make sure it works
    // ///////////////
    // // Listeners ///
    // ////////////////
    var expandTimeout = void 0;
    this.buttonContainer.addEventListener('click', _analytics.onButtonClick);
    this.buttonContainer.addEventListener('mouseenter', function () {
      expandTimeout = _this.handleExpandButton(250);
      // Google Analytics:
      if (true) {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Button',
          eventAction: 'hover'
        });
      }
    });

    this.buttonContainer.addEventListener('mouseleave', function () {
      _this.handleCollapseButton(expandTimeout);
    });

    this.render();

    return this.buttonContainer;
  },
  handleExpandButton: function handleExpandButton(wait) {
    var _this2 = this;

    this.buttonContainer.className += ' ' + _widgetButton2.default.hover;
    this.button.style.borderWidth = '1px';
    return setTimeout(function () {
      _this2.buttonExpand.style.opacity = '1';
    }, wait);
  },
  handleCollapseButton: function handleCollapseButton(timeout) {
    clearTimeout(timeout);
    (0, _domHelpers.removeClass)(this.buttonContainer, _widgetButton2.default.hover);
    this.button.style.borderWidth = '0px';
    this.buttonExpand.style.opacity = '0';
  },
  render: function render() {
    var _this3 = this;

    var available = _widgetController.widgetCtrl.getNumberBookingsAvailable();
    if (available.length) {
      this.indicator.textContent = available.length;
      this.indicatorText.textContent = available.length + ' Spot' + (available.length > 1 ? 's' : '') + ' Available This Week!';
    } else {
      this.indicator.style.display = 'none';
    }

    this.handleExpandButton(0);
    setTimeout(function () {
      _this3.handleCollapseButton();
    }, 15000);
  }
};

exports.default = widgetButton;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(44);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"attrs":{"id":"widget-styles"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./widgetButton.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./widgetButton.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".openchair_widgetButton__container--i6KaU{height:75px;width:75px;-webkit-box-sizing:border-box;box-sizing:border-box;position:fixed;right:34px;bottom:20px;display:-webkit-box;display:-ms-flexbox;display:flex;border-radius:37.5px;padding:0;margin:0;-webkit-box-shadow:0 6px 20px 0 rgba(0,0,0,.3);box-shadow:0 6px 20px 0 rgba(0,0,0,.3);color:#fff;cursor:pointer;font-size:60px;z-index:1000000;-webkit-transition:width .3s ease-out;-o-transition:width .3s ease-out;transition:width .3s ease-out;overflow:visible}.openchair_widgetButton__container--i6KaU,.openchair_widgetButton__container--i6KaU:focus,.openchair_widgetButton__container--i6KaU:hover{border:none;background-image:-webkit-gradient(linear,left top,left bottom,from(#949494),to(#696969));background-image:-webkit-linear-gradient(#949494,#696969);background-image:-o-linear-gradient(#949494,#696969);background-image:linear-gradient(#949494,#696969)}.openchair_widgetButton__button--2c-MZ{height:75px;width:75px;min-width:75px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:37.5px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:0 solid #f8f8f8;position:absolute;top:0;right:0}.openchair_widgetButton__icon--23dbc{width:40px;height:45px;color:#f8f8f8}.openchair_widgetButton__indicatorDot--1_XYq{height:32px;width:32px;position:absolute;top:-7px;right:-7px;line-height:32px;vertical-align:middle;border-radius:50%;background-color:#ff3b30;font-family:Lato,sans-serif;font-style:normal;font-size:16px;font-weight:900;text-align:center;color:#f8f8f8}.openchair_widgetButton__expand--xEXZz{height:75px;width:0;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:0}.openchair_widgetButton__indicatorText--3HG0h{font-family:Lato,sans-serif;font-size:14px;font-weight:900;line-height:1.25;letter-spacing:1.5px;text-align:left;text-transform:uppercase}.openchair_widgetButton__mainText--1Jg97{font-family:Lato,sans-serif;font-size:18px;line-height:1.39;letter-spacing:1.2px;text-align:left;color:#fff;text-transform:uppercase;font-weight:400}.openchair_widgetButton__hover--3R_Ud .openchair_widgetButton__expand--xEXZz{width:285px;padding-left:6px}.openchair_widgetButton__hover--3R_Ud{width:360px}@media only screen and (max-width:768px){.openchair_widgetButton__container--i6KaU{height:56px;width:56px;border-radius:28px;right:15px;bottom:30px}.openchair_widgetButton__button--2c-MZ{height:56px;width:56px;border-radius:28px;min-width:56px;max-width:56px}.openchair_widgetButton__icon--23dbc{width:28.5px;height:31px}.openchair_widgetButton__indicatorDot--1_XYq{height:24px;width:24px;top:-4px;right:-4px;font-size:12px;font-size:calc(10.78261px + .17391vw);line-height:24px}.openchair_widgetButton__expand--xEXZz{height:56px}.openchair_widgetButton__hover--3R_Ud .openchair_widgetButton__expand--xEXZz{width:230px}.openchair_widgetButton__hover--3R_Ud{width:286px}.openchair_widgetButton__indicatorText--3HG0h{font-size:10px;font-size:calc(8.78261px + .17391vw)}.openchair_widgetButton__mainText--1Jg97{font-size:12px;font-size:calc(10.78261px + .17391vw)}}", ""]);

// exports
exports.locals = {
	"container": "openchair_widgetButton__container--i6KaU",
	"button": "openchair_widgetButton__button--2c-MZ",
	"icon": "openchair_widgetButton__icon--23dbc",
	"indicatorDot": "openchair_widgetButton__indicatorDot--1_XYq",
	"expand": "openchair_widgetButton__expand--xEXZz",
	"indicatorText": "openchair_widgetButton__indicatorText--3HG0h",
	"mainText": "openchair_widgetButton__mainText--1Jg97",
	"hover": "openchair_widgetButton__hover--3R_Ud"
};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABMCAYAAAA7gnrhAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0dJREFUeNrsXNFx4jAQFZl88Gk6sCuIr4IzFUAHkApIKrhcBUAFcBXcUUHcQeggdHB88pfbPdYZx7GJhCxpDftmdkKMhaTn3dVqZUkpAxwOhyeQN5InxRS27ewZVvZW/r/f7/eYkmLVzhslEFKElDNxW7HFCP5MQUYgma5NVm04FAzbuQXZgKyh3K7W0UIBJOE3SNRUWZMD40aKYTv3II9wz/qD+RAhz3WEXAGwzyvg4OGdFDKZlXgSNQcu4kJTxiCxcPIfPwpSRsLFO7KypgiOiCVOqR+2U1NSfjZ85gabdkY9zRhjCON43sBsMZxzgHU7MabR1ZTszO+COErbdupqyp6ewrZqf8yCPut2oqb0DEJ0rHAJkpeYnzGMgq3aaUrKVcDEp0g+RUgRCCkCgUDgGxK8SfAmQ7KQIqR0nBScxmM6MEEHRit1A5AhXc9ryuT0Hd4zKJVL6Pquq6NPkdNYQIf2X91MSSBVTQ413It5EVzNc5LLcZVPwY7d63TQBrSah2vfKXdSUCu+VVfxHRKDmvLapsa4iFMefRFCHcCHcM/Zp+ygkUmI0QL68NKWGbWtKcuAo2irdbdJyp+ApOQcSdn79CU1Kr8jJ8+KlK0Kjy1H85EwX0gRUs5CyqAvMTdSIgq5g4DqjjmaTxZQS1KO5oP4HpCUEVdSQr5lOeZKSgy27Z0Yepct5koKYhJAS1qv00XmLfGYZEINeW15HuVkMWzmUUumXYloffqVUVdIiYstIh4CtrQrpLQacoeYWrgiJesyKbehZ3GlzZyItc7iWTHfulhS1HFBKys5zuGlpA7O1ZJpxdQyuna9pDTENLNLJeVOQ0vSBmeZFgvutnVwI0XHCU4so2JnjtbZi4AaW+z/nugYriMNvijvrN3OfApN6U852FNPOjrlcE/9NndHO7Gc7s98z3mcm486LmMm1WDMcCPmp42SLt5JqTOf3KGzrTtDYW7wG/OGa66cbF6Yz8ahJo7hyeKJExHJynDOktaUdxncbQrzwRnti7rOY0Jqzf2GUodLJVgW/q980s6z4rXx2idyIGT4aUimi4srJGRRJuSDplSGzAlpTXyhROxopPlVdzaC1kl5riNIn85U56XnfwIMAG7obZPRsKtaAAAAAElFTkSuQmCC"

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locations = __webpack_require__(19);

var _locations2 = _interopRequireDefault(_locations);

var _calendar = __webpack_require__(9);

var _calendar2 = _interopRequireDefault(_calendar);

var _domHelpers = __webpack_require__(1);

var _widgetModal = __webpack_require__(13);

var _widgetModal2 = _interopRequireDefault(_widgetModal);

var _widgetController = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calendarView = {
  init: function init() {
    this.locationsElem = _locations2.default.init();
    this.calendarElem = _calendar2.default.init();

    this.calendarViewContainer = (0, _domHelpers.createEl)('div', _widgetModal2.default.calendarView);
    this.calendarViewContainer.append(this.calendarElem, this.locationsElem);

    return this.calendarViewContainer;
  },
  render: function render() {
    _widgetController.widgetCtrl.setCurrentDay(null);
    _calendar2.default.render();
    _locations2.default.render();
  }
};

exports.default = calendarView;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(49);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"attrs":{"id":"widget-styles"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./calendar.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./calendar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports
exports.i(__webpack_require__(2), undefined);

// module
exports.push([module.i, ".openchair_calendar__calendar--1k42o{width:50%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around}.openchair_calendar__weekContainer--1sFQt{width:100%;height:16%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 4px;background-color:transparent;color:#f8f8f8;border-top:2px solid hsla(0,0%,97%,.5);border-bottom:2px solid hsla(0,0%,97%,.5)}.openchair_calendar__week--1cgoM,.openchair_calendar__weekContainer--1sFQt{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-negative:0;flex-shrink:0}.openchair_calendar__week--1cgoM{height:100%;width:90%;overflow:hidden;white-space:nowrap}.openchair_calendar__day---e_AH{height:100%;width:14.285%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-negative:0;flex-shrink:0;cursor:pointer}.openchair_calendar__day---e_AH,.openchair_calendar__dayOfWeek--1BUHB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.openchair_calendar__dayOfWeek--1BUHB{height:25%;font-size:14px;font-size:calc(12.78261px + .17391vw);font-weight:900}.openchair_calendar__dayOfWeek--1BUHB,.openchair_calendar__month--zD1PI{width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-family:Lato,sans-serif}.openchair_calendar__month--zD1PI{height:20%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:transparent;font-weight:400;font-size:12px;font-size:calc(10.78261px + .17391vw);letter-spacing:.9px;text-transform:uppercase}.openchair_calendar__dateTimeLabel--dodab{background-color:none;display:none;font-family:Lato,sans-serif;font-size:12px;letter-spacing:1px;text-align:center;margin:2px 0;padding:4px 0 8px;text-transform:uppercase;vertical-align:bottom}.openchair_calendar__dayOfMonth--Crr6e{height:35%;width:100%;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-family:Lato,sans-serif;font-weight:700;font-size:16px;font-size:calc(14.78261px + .17391vw);margin-bottom:6px}.openchair_calendar__dayOfMonthInner--3eGPl{border:1px solid;border-radius:15px;text-align:center;height:29px;width:29px;line-height:29px}.openchair_calendar__isActive--25zAX .openchair_calendar__dayOfMonthInner--3eGPl{background:#f8f8f8;border:none;border-radius:30px;height:30px;width:30px;line-height:30px}.openchair_calendar__isUnavailable--1AoEB .openchair_calendar__dayOfMonthInner--3eGPl{border:none}.openchair_calendar__isActive--25zAX .openchair_calendar__dayOfMonth--Crr6e{color:#696969;-webkit-transition:color .3s linear;-o-transition:color .3s linear;transition:color .3s linear}.openchair_calendar__isActive--25zAX .openchair_calendar__dayOfMonth--Crr6e:before{background-color:#f8f8f8;-webkit-transition:background-color .3s linear;-o-transition:background-color .3s linear;transition:background-color .3s linear;z-index:-1;display:-webkit-inline-flex;border:none}.openchair_calendar__isActive--25zAX .openchair_calendar__month--zD1PI{color:#f8f8f8}.openchair_calendar__isUnavailable--1AoEB .openchair_calendar__dayOfMonth--Crr6e{font-weight:400}.openchair_calendar__isUnavailable--1AoEB .openchair_calendar__dayOfMonth--Crr6e:before{border:none}.openchair_calendar__timesContainer--HyCaB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:2;flex-shrink:2;width:100%;overflow-y:auto}.openchair_calendar__timesInstruction--12Yqf{-webkit-box-sizing:border-box;box-sizing:border-box;padding:5px;border-bottom:1px solid hsla(0,0%,97%,.65);white-space:pre-line}.openchair_calendar__timesInstruction--12Yqf,.openchair_calendar__timesOverlay--16vh9{width:100%;font-family:Lato,sans-serif;font-size:14px;font-size:calc(12.78261px + .17391vw);text-align:center;font-weight:400}.openchair_calendar__timesOverlay--16vh9{display:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.openchair_calendar__overlayText--1w5XO{padding:6px;font-weight:400;white-space:pre-line}.openchair_calendar__nextAppointmentLink--xviOj,.openchair_calendar__overlayText--1w5XO{font-family:Lato,sans-serif;font-size:16px;font-size:calc(14.78261px + .17391vw);text-align:center}.openchair_calendar__nextAppointmentLink--xviOj{font-weight:700;cursor:pointer;text-decoration:none}.openchair_calendar__nextAppointmentLink--xviOj:hover{text-decoration:underline}.openchair_calendar__times--4-MIc{width:100%;height:100%}.openchair_calendar__time--3neJB{width:100%;height:11%;padding:15px;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid hsla(0,0%,97%,.65);font-family:Lato,sans-serif;font-size:calc(12.78261px + .17391vw);text-align:center;font-weight:400;cursor:pointer}.openchair_calendar__time--3neJB:hover{background-color:#f8f8f8;background-color:hsla(0,0%,97%,.2)}.openchair_calendar__arrow--8w7hH{width:28px;height:28px;font-size:28px;text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center;cursor:pointer}.openchair_calendar__linkArrow--1mgI6{font-size:20px;vertical-align:bottom}.openChair__lightTheme .openchair_calendar__time--3neJB,.openChair__lightTheme .openchair_calendar__timesInstruction--12Yqf{border-bottom:1px solid hsla(0,0%,41%,.5)}.openChair__lightTheme .openchair_calendar__weekContainer--1sFQt{color:#696969;background:#f7f7f7}.openChair__lightTheme .openchair_calendar__isActive--25zAX .openchair_calendar__dayOfMonth--Crr6e{color:#f8f8f8}.openChair__lightTheme .openchair_calendar__isActive--25zAX .openchair_calendar__month--zD1PI{color:#696969}.openChair__lightTheme .openchair_calendar__isActive--25zAX .openchair_calendar__dayOfMonthInner--3eGPl{background-color:#696969}.openChair__lightTheme .openchair_calendar__weekContainer--1sFQt{border-top:none}.openChair__lightTheme .openchair_calendar__dateTimeLabel--dodab,.openChair__lightTheme .openchair_calendar__time--3neJB:hover{background-color:#f7f7f7}@media only screen and (max-width:768px){.openchair_calendar__calendar--1k42o{width:100%}.openchair_calendar__dateTimeLabel--dodab{display:block}.openchair_calendar__weekContainer--1sFQt{height:100px}.openchair_calendar__week--1cgoM{width:100%}.openchair_calendar__arrow--8w7hH{display:none}.openchair_calendar__dayOfMonth--Crr6e{font-size:18px;max-width:54px}.openchair_calendar__dayOfMonth--Crr6e:before{width:31.5px;height:31.5px}.openchair_calendar__timesContainer--HyCaB{overflow-y:auto;-webkit-overflow-scrolling:touch}.openchair_calendar__time--3neJB{height:58px}}", ""]);

// exports
exports.locals = {
	"calendar": "openchair_calendar__calendar--1k42o",
	"weekContainer": "openchair_calendar__weekContainer--1sFQt",
	"week": "openchair_calendar__week--1cgoM",
	"day": "openchair_calendar__day---e_AH",
	"dayOfWeek": "openchair_calendar__dayOfWeek--1BUHB",
	"month": "openchair_calendar__month--zD1PI",
	"dateTimeLabel": "openchair_calendar__dateTimeLabel--dodab",
	"dayOfMonth": "openchair_calendar__dayOfMonth--Crr6e",
	"dayOfMonthInner": "openchair_calendar__dayOfMonthInner--3eGPl",
	"isActive": "openchair_calendar__isActive--25zAX",
	"isUnavailable": "openchair_calendar__isUnavailable--1AoEB",
	"timesContainer": "openchair_calendar__timesContainer--HyCaB",
	"timesInstruction": "openchair_calendar__timesInstruction--12Yqf",
	"timesOverlay": "openchair_calendar__timesOverlay--16vh9",
	"overlayText": "openchair_calendar__overlayText--1w5XO",
	"nextAppointmentLink": "openchair_calendar__nextAppointmentLink--xviOj",
	"times": "openchair_calendar__times--4-MIc",
	"time": "openchair_calendar__time--3neJB",
	"arrow": "openchair_calendar__arrow--8w7hH " + __webpack_require__(2).locals["material-icons"] + "",
	"linkArrow": "openchair_calendar__linkArrow--1mgI6 " + __webpack_require__(2).locals["material-icons"] + ""
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"attrs":{"id":"widget-styles"}}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./locations.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js!./locations.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports
exports.i(__webpack_require__(2), undefined);

// module
exports.push([module.i, ".openchair_locations__locations--3YAYQ{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:50%;height:100%;padding:0;-webkit-transition:height .3s ease-in-out;-o-transition:height .3s ease-in-out;transition:height .3s ease-in-out}.openchair_locations__map--20uFi{height:100%;width:100%}.openchair_locations__selectToggle--37-lK{display:none}.openchair_locations__dateTimeLabel--2it4t{transform-text:uppercase}.openchair_locations__desktopTopBox--1GJNj{background-color:#f8f8f8;font-size:14px;font-size:calc(12.78261px + .17391vw);color:#696969;font-family:Lato,sans-serif;padding:4px;text-align:center}.openchair_locations__desktopBottomBox--2kgeH{white-space:pre-line;padding:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.openchair_locations__address--228Ui{font-size:16px;font-size:calc(14.78261px + .17391vw);color:#696969;font-family:Lato,sans-serif;font-weight:700;line-height:22px}.openchair_locations__address--228Ui:first-child{font-size:14px;font-size:calc(12.78261px + .17391vw);font-weight:400}.openChair__lightTheme .openchair_locations__desktopTopBox--1GJNj,.openChair__lightTheme .openchair_locations__toggleLine--3r5kJ{background-color:#f7f7f7}@media only screen and (max-width:768px){.openchair_locations__desktopBottomBox--2kgeH,.openchair_locations__desktopTopBox--1GJNj{display:none}.openchair_locations__locations--3YAYQ{width:100%;height:50%;max-height:400px;-ms-flex-negative:0;flex-shrink:0}.openchair_locations__selectToggle--37-lK{height:28px;display:block;width:100%}.openchair_locations__isExpanded--3o7bl{height:50%}.openchair_locations__isHidden--1wEnW{height:28px}.openchair_locations__isExpanded--3o7bl .openchair_locations__map--20uFi{height:100%}.openchair_locations__isHidden--1wEnW .openchair_locations__map--20uFi{height:0}.openchair_locations__toggleArrow--3-XzJ{width:20px;height:20px;font-size:20px;text-align:left}.openchair_locations__toggleText--3_QKI{font-family:Lato,sans-serif;text-transform:uppercase;font-size:12px;letter-spacing:1px;vertical-align:bottom;text-align:center}.openchair_locations__toggleLine--3r5kJ{height:28px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}", ""]);

// exports
exports.locals = {
	"locations": "openchair_locations__locations--3YAYQ",
	"map": "openchair_locations__map--20uFi",
	"selectToggle": "openchair_locations__selectToggle--37-lK",
	"dateTimeLabel": "openchair_locations__dateTimeLabel--2it4t",
	"desktopTopBox": "openchair_locations__desktopTopBox--1GJNj",
	"desktopBottomBox": "openchair_locations__desktopBottomBox--2kgeH openchair_locations__desktopTopBox--1GJNj",
	"address": "openchair_locations__address--228Ui",
	"toggleLine": "openchair_locations__toggleLine--3r5kJ",
	"isExpanded": "openchair_locations__isExpanded--3o7bl",
	"isHidden": "openchair_locations__isHidden--1wEnW",
	"toggleArrow": "openchair_locations__toggleArrow--3-XzJ " + __webpack_require__(2).locals["material-icons"] + "",
	"toggleText": "openchair_locations__toggleText--3_QKI"
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports
exports.i(__webpack_require__(2), undefined);
exports.i(__webpack_require__(14), undefined);

// module
exports.push([module.i, ".openchair_widgetModal__container--bojMg{width:100vw;height:100vh;position:fixed;top:0;left:0;display:none;background-color:#f8f8f8;background-color:hsla(0,0%,97%,.75);z-index:1000000}.openchair_widgetModal__modal--3H5Be{width:52vw;height:38vw;min-width:750px;min-height:550px;max-width:1000px;max-height:740px;position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;background-image:-webkit-linear-gradient(324deg,#949494,#696969);background-image:-o-linear-gradient(324deg,#949494,#696969);background-image:linear-gradient(126deg,#949494,#696969);-webkit-box-shadow:0 6px 20px 0 rgba(0,0,0,.3);box-shadow:0 6px 20px 0 rgba(0,0,0,.3);color:#f8f8f8}.openChair__darkTheme{background:-webkit-linear-gradient(324deg,#949494,#696969);background:-o-linear-gradient(324deg,#949494,#696969);background:linear-gradient(126deg,#949494,#696969)}.openChair__lightTheme{background:#fbfbfb;color:#696969}.openchair_widgetModal__header--qLanB{height:62px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:4px 0 8px}.openChair__lightTheme .openchair_widgetModal__header--qLanB{background:#f7f7f7}.openchair_widgetModal__officeName--2G8L1{margin:auto;padding-left:40px;font-family:Lato,sans-serif;font-size:24px;font-weight:700;letter-spacing:4px;text-transform:uppercase;text-align:center;font-style:normal}.openchair_widgetModal__closeBtn--_ExEG{width:30px;height:30px;font-size:30px;text-align:left;border:none;color:inherit;cursor:pointer;background-color:transparent;padding:0;margin:0;margin-right:10px}.openchair_widgetModal__closeBtn--_ExEG:focus,.openchair_widgetModal__closeBtn--_ExEG:hover{opacity:.65;background-color:transparent;border:none}.openchair_widgetModal__body--fy9WV{display:-webkit-box;display:-ms-flexbox;display:flex;height:calc(100% - 62px)}.openchair_widgetModal__body--fy9WV,.openchair_widgetModal__calendarView--2eFBs{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:100%}.openchair_widgetModal__calendarView--2eFBs{display:none;height:100%;-ms-flex-pack:distribute;justify-content:space-around}.openchair_widgetModal__noscroll--2NCDZ{overflow:hidden}.openchair_widgetModal__divider--VMPrc{height:1px;display:none;background-color:#f8f8f8;background-color:hsla(0,0%,97%,.5);margin:10px 0 30px;width:20%;margin:4px auto 0;position:relative;top:2px}.openchair_widgetModal__spinner--3yu_F{position:absolute;top:0;left:0;height:100%;width:100%;background-color:#f8f8f8;background-color:hsla(0,0%,97%,.3);display:none}.openchair_widgetModal__spinner--3yu_F:before{content:\"\";-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;top:50%;left:50%;width:40px;height:40px;margin-top:-10px;margin-left:-10px;border-radius:50%;border:2px solid #f8f8f8;border-top-color:#696969;-webkit-animation:openchair_widgetModal__spinner--3yu_F .6s linear infinite;animation:openchair_widgetModal__spinner--3yu_F .6s linear infinite}@-webkit-keyframes openchair_widgetModal__spinner--3yu_F{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes openchair_widgetModal__spinner--3yu_F{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.openchair_widgetModal__error--1Q541{background-image:none;-webkit-box-shadow:none;box-shadow:none;background-color:#f8f8f8;background-color:hsla(0,0%,97%,.8);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.openchair_widgetModal__errorText--1l-Oe{padding-bottom:12px;color:#696969;font-family:Lato,sans-serif;font-size:18px;font-size:calc(16.78261px + .17391vw);font-weight:700;white-space:pre-line;text-align:center}.openchair_widgetModal__errorButton--1XAap{width:140px;background-color:transparent;border:2px solid #949494}.openchair_widgetModal__errorButton--1XAap:hover{border:2px solid #949494}@media only screen and (max-width:768px){.openchair_widgetModal__container--bojMg{top:0;left:0;right:0;bottom:0;overflow:auto}.openchair_widgetModal__noscroll--2NCDZ{-webkit-overflow-scrolling:auto}.openchair_widgetModal__header--qLanB{position:absolute;top:0}.openchair_widgetModal__body--fy9WV{position:absolute;top:60px}.openchair_widgetModal__modal--3H5Be{width:100vw;height:100%;min-width:100vw;min-height:675px;max-height:100%;overflow:auto;position:static;-webkit-transform:translate(0);transform:translate(0)}.openchair_widgetModal__calendarView--2eFBs{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.openchair_widgetModal__officeName--2G8L1{font-size:20px}.openchair_widgetModal__divider--VMPrc{display:block;top:-2px;width:30%}.openChair__lightTheme .openchair_widgetModal__divider--VMPrc{display:none}.openChair__lightTheme .openchair_widgetModal__calendarView--2eFBs{margin-top:2px}}", ""]);

// exports
exports.locals = {
	"container": "openchair_widgetModal__container--bojMg",
	"modal": "openchair_widgetModal__modal--3H5Be",
	"header": "openchair_widgetModal__header--qLanB",
	"officeName": "openchair_widgetModal__officeName--2G8L1",
	"closeBtn": "openchair_widgetModal__closeBtn--_ExEG " + __webpack_require__(2).locals["material-icons"] + "",
	"body": "openchair_widgetModal__body--fy9WV",
	"calendarView": "openchair_widgetModal__calendarView--2eFBs",
	"noscroll": "openchair_widgetModal__noscroll--2NCDZ",
	"divider": "openchair_widgetModal__divider--VMPrc",
	"spinner": "openchair_widgetModal__spinner--3yu_F",
	"error": "openchair_widgetModal__error--1Q541 openchair_widgetModal__modal--3H5Be",
	"errorText": "openchair_widgetModal__errorText--1l-Oe",
	"errorButton": "openchair_widgetModal__errorButton--1XAap " + __webpack_require__(14).locals["buttonConfirm"] + ""
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _addToCalendar = __webpack_require__(54);

var addToCalendar = _interopRequireWildcard(_addToCalendar);

var _momentTimezone = __webpack_require__(6);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _ravenJs = __webpack_require__(3);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _form = __webpack_require__(55);

var _form2 = _interopRequireDefault(_form);

var _infoTables = __webpack_require__(56);

var _infoTables2 = _interopRequireDefault(_infoTables);

var _appointmentView = __webpack_require__(15);

var _appointmentView2 = _interopRequireDefault(_appointmentView);

var _widgetModal = __webpack_require__(10);

var _widgetModal2 = _interopRequireDefault(_widgetModal);

var _domHelpers = __webpack_require__(1);

var _analytics = __webpack_require__(7);

var _calendar = __webpack_require__(9);

var _widgetController = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function createCalIcon(name, srcString, href) {
  var icon = (0, _domHelpers.createEl)('a', _appointmentView2.default.calendarBtn, '', { target: 'blank', href: href });
  icon.append((0, _domHelpers.createEl)('img', _appointmentView2.default.calendarIcon, '', { src: srcString }), (0, _domHelpers.createEl)('span', _appointmentView2.default.calendarName, name));
  return icon;
}

function makeCalendarEvent() {
  var appointment = _widgetController.widgetCtrl.getAppointmentInfo();
  var location = _widgetController.widgetCtrl.getCurrentLocation();
  return {
    title: 'First appointment at ' + _widgetController.widgetCtrl.getPracticeName(),
    start: _momentTimezone2.default.tz(appointment.start_datetime, _widgetController.widgetCtrl.getTz()).format('YYYYMMDDTHHmmss'),
    end: _momentTimezone2.default.tz(appointment.start_datetime, _widgetController.widgetCtrl.getTz()).add(appointment.length, 'minutes').format('YYYYMMDDTHHmmss'),
    address: location.street_address + ', ' + location.city + ', ' + location.state + ' ' + location.zip
  };
}

var appointmentView = {
  init: function init() {
    this.appointmentInfoView = (0, _domHelpers.createEl)('div', _appointmentView2.default.appointmentInfoView);

    this.formView = this.initFormView();
    return this.appointmentInfoView;
  },
  initFooter: function initFooter() {
    var footer = (0, _domHelpers.createEl)('div', _appointmentView2.default.footer);
    footer.append((0, _domHelpers.createEl)('span', _appointmentView2.default.footerText, 'Powered by Rooster Grin Media'), (0, _domHelpers.createEl)('img', _appointmentView2.default.footerLogo, '', { src: __webpack_require__(57) }));
    return footer;
  },
  initFormView: function initFormView() {
    var _this = this;

    var formElem = _form2.default.init();
    formElem.addEventListener('submit', function (event) {
      event.preventDefault();
      var patient = (0, _domHelpers.getFormData)(formElem);
      var orthoconfirm = formElem.querySelector('#openchair-orthoconfirm select');
      if (orthoconfirm && orthoconfirm.value === 'no') {
        var officePhone = _widgetController.widgetCtrl.getCurrentLocation().office_phone;
        _widgetController.widgetCtrl.showError('You can only book braces or invisalign consultation through this system.\nPlease call the office at ' + officePhone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2)$3-$4') + ' to book other types of appointments.');
      }
      _widgetController.widgetCtrl.setPatientInfo(patient);
      _this.renderReviewView();
    });
    var bookingContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.bookingContainer);

    var infoContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.infoContainer);
    infoContainer.append(formElem, bookingContainer);

    var goBackBtn = (0, _domHelpers.createBtn)(_appointmentView2.default.buttonCancel, '< Back');
    var booking = _widgetController.widgetCtrl.getAppointmentInfo();
    var buttonText = '';
    if (booking) {
      buttonText = booking.automation ? 'Review Details' : 'Next';
    }
    var nextBtn = (0, _domHelpers.createEl)('button', _appointmentView2.default.buttonConfirm, buttonText, { type: 'submit' });
    nextBtn.addEventListener('click', _analytics.onFormSubmissionClick);
    // submit button outside the form tag is not supported by ie
    // this is some hacking to work around that
    nextBtn.addEventListener('click', function () {
      // Google Analytics:
      if (true) {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Form',
          eventAction: 'next'
        });
      }

      var submitInsideForm = nextBtn.cloneNode();
      formElem.appendChild(submitInsideForm);
      submitInsideForm.click();
      formElem.removeChild(submitInsideForm);
    });

    goBackBtn.addEventListener('click', _widgetModal2.default.onEditAppointmentClick);

    var buttonsContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.buttonsContainer);
    buttonsContainer.append(goBackBtn, nextBtn);
    var formView = (0, _domHelpers.createEl)('div', _appointmentView2.default.appointmentInfoSubView);
    formView.append(infoContainer, buttonsContainer);

    return {
      view: formView,
      render: function render() {
        bookingContainer.innerHTML = '';
        bookingContainer.append(_infoTables2.default.booking.render());
      }
    };
  },
  initReviewView: function initReviewView() {
    var _this2 = this;

    var booking = _widgetController.widgetCtrl.getAppointmentInfo();
    var reviewMessage = (0, _domHelpers.createEl)('div', _appointmentView2.default.confirmMessage);
    var reviewText = booking.automation ? 'Please review appointment details.' : 'Please review the information below to schedule your initial consultation:';
    reviewMessage.append((0, _domHelpers.createEl)('p', _appointmentView2.default.confirmMessageLine, reviewText));
    var bookingContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.bookingContainer);
    var editAppointmentBtn = (0, _domHelpers.createBtn)(_appointmentView2.default.buttonCancel, '< Edit appointment info');
    editAppointmentBtn.addEventListener('click', function () {
      // Google Analytics:
      if (true) {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Form',
          eventAction: 'back'
        });
      }
      _widgetModal2.default.onEditAppointmentClick();
    });

    var patientContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.patientContainer);
    var editPatientBtn = (0, _domHelpers.createBtn)(_appointmentView2.default.buttonCancel, '< Edit patient info');
    editPatientBtn.addEventListener('click', function () {
      // Google Analytics:
      if (true) {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Form',
          eventAction: 'back'
        });
      }
      _this2.renderFormView();
    });

    var infoContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.infoContainer);
    infoContainer.append(patientContainer, bookingContainer);

    var buttonsContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.buttonsContainer);
    var innerContainer = (0, _domHelpers.createEl)('div', 'innerContainer');
    var lookGood = (0, _domHelpers.createEl)('div', _appointmentView2.default.lookGood, 'Look good?');
    var buttonText = 'Submit';
    var submitButtonText = booking && booking.automation ? 'request appointment' : 'submit';
    var submitBtn = (0, _domHelpers.createEl)('button', _appointmentView2.default.buttonConfirm, submitButtonText);
    submitBtn.addEventListener('click', _analytics.onRequestSubmission);
    innerContainer.append(lookGood, submitBtn);
    submitBtn.addEventListener('click', this.onSubmitClick.bind(this));
    buttonsContainer.append(innerContainer);

    var reviewView = (0, _domHelpers.createEl)('div', _appointmentView2.default.appointmentInfoSubView);
    reviewView.append(reviewMessage, infoContainer, buttonsContainer);

    return {
      view: reviewView,
      render: function render() {
        var infoTablesSection = _infoTables2.default.booking.render();
        var messageSection = infoTablesSection.querySelector('.openchair-message-section');
        if (messageSection) {
          messageSection.remove();
        }
        bookingContainer.innerHTML = '';
        bookingContainer.prepend(infoTablesSection, editAppointmentBtn);
        patientContainer.innerHTML = '';
        patientContainer.prepend(_infoTables2.default.patient.render(), editPatientBtn);
      }
    };
  },
  confirmationMessage: function confirmationMessage(booking) {
    var location = _widgetController.widgetCtrl.getCurrentLocation();
    var timeText = (0, _momentTimezone2.default)(booking.start_datetime).format('ddd, MMM Do');
    var automation = booking && booking.automation;
    var secondLine = automation ? '' : 'An email confirmation has been sent with your appointment information. ';
    var thirdLine = automation ? 'Thank you for requesting an appointment on ' + timeText + ' at ' + location.name + '. The details of your request have been emailed to you. You will be receiving a second email shortly to confirm your exact appointment time.' : 'We look forward to meeting you on ';
    return ['Congratulations on taking the first step toward a beautiful new smile! ', secondLine, thirdLine];
  },
  initConfirmationView: function initConfirmationView() {
    var _this3 = this;

    var confirmationMessage = (0, _domHelpers.createEl)('div', _appointmentView2.default.confirmMessage, '', {
      style: 'position: relative; top: 12%;'
    });
    var timeMessage = (0, _domHelpers.createEl)('p', _appointmentView2.default.confirmMessageLine, '', { style: 'font-weight: bold;' });
    var booking = _widgetController.widgetCtrl.getAppointmentInfo();

    var _confirmationMessage = this.confirmationMessage(booking),
        _confirmationMessage2 = _slicedToArray(_confirmationMessage, 3),
        firstLine = _confirmationMessage2[0],
        secondLine = _confirmationMessage2[1],
        thirdLine = _confirmationMessage2[2];

    confirmationMessage.append((0, _domHelpers.createEl)('p', _appointmentView2.default.confirmMessageLine, firstLine, { style: 'display: block' }), (0, _domHelpers.createEl)('p', _appointmentView2.default.confirmMessageLine, secondLine), (0, _domHelpers.createEl)('p', _appointmentView2.default.confirmMessageLine, thirdLine), booking && !booking.automation ? timeMessage : '');

    var calendarButtons = (0, _domHelpers.createEl)('div', _appointmentView2.default.calendars);
    var addToCalendarBtn = (0, _domHelpers.createEl)('button', _appointmentView2.default.buttonConfirm, 'Add to Calendar');
    addToCalendarBtn.addEventListener('click', function () {
      calendarButtons.innerHTML = '';
      calendarButtons.append(_this3.renderCalendarButtons());
      calendarButtons.style.display = 'flex';
      addToCalendarBtn.style.display = 'none';
    });
    var buttonsContainer = (0, _domHelpers.createEl)('div', _appointmentView2.default.buttonsContainer);
    buttonsContainer.append(addToCalendarBtn, calendarButtons);
    var confirmationView = (0, _domHelpers.createEl)('div', _appointmentView2.default.appointmentInfoSubView);
    confirmationView.append(confirmationMessage, buttonsContainer);

    return {
      view: confirmationView,
      render: function render() {
        var datetime = _momentTimezone2.default.tz(_widgetController.widgetCtrl.getAppointmentInfo().start_datetime, _widgetController.widgetCtrl.getTz());
        timeMessage.textContent = datetime.format('dddd, MMMM D YYYY') + ' at ' + datetime.format('h:mm A') + '.';

        calendarButtons.style.display = 'none';
        addToCalendarBtn.style.display = 'block';
      }
    };
  },
  renderCalendarButtons: function renderCalendarButtons() {
    var event = makeCalendarEvent();
    var tz = _widgetController.widgetCtrl.getTz();
    var buttonsFragment = document.createDocumentFragment();
    buttonsFragment.append(createCalIcon('Google', __webpack_require__(58), addToCalendar.google(event, tz)), createCalIcon('Apple', __webpack_require__(59), addToCalendar.ics(event, tz)), createCalIcon('Outlook', __webpack_require__(60), addToCalendar.ics(event, tz)));
    return buttonsFragment;
  },
  onSubmitClick: function onSubmitClick() {
    var _this4 = this;

    // Google Analytics:
    if (true) {
      ga('openchair.send', {
        hitType: 'event',
        eventCategory: 'Form',
        eventAction: 'submit'
      });
    }
    _widgetModal2.default.toggleSpinner();
    _widgetController.widgetCtrl.confirmBooking().then(function () {
      _this4.renderConfirmationView();
      setTimeout(_widgetModal2.default.toggleSpinner.bind(_widgetModal2.default), 100);
    }).catch(function (err) {
      setTimeout(_widgetModal2.default.toggleSpinner.bind(_widgetModal2.default), 100);
      _widgetController.widgetCtrl.showError();
      _ravenJs2.default.captureException(err);
    });
  },
  clearForm: function clearForm() {
    _form2.default.render();
  },
  buildFormView: function buildFormView() {
    if (this.formView) {
      this.formView.view.remove();
    }
    this.formView = this.initFormView();
    this.appointmentInfoView.append(this.formView.view);
  },
  buildReviewView: function buildReviewView() {
    if (this.reviewView) {
      this.reviewView.view.remove();
    }
    this.reviewView = this.initReviewView();
    this.appointmentInfoView.append(this.reviewView.view);
  },
  buildConfirmationView: function buildConfirmationView() {
    if (this.confirmationView) {
      this.confirmationView.view.remove();
    }
    this.confirmationView = this.initConfirmationView();
    this.appointmentInfoView.append(this.confirmationView.view);
  },
  renderFooter: function renderFooter() {
    if (this.footer) {
      this.footer.remove();
    }
    this.footer = this.initFooter();
    this.appointmentInfoView.append(this.footer);
  },
  renderFormView: function renderFormView() {
    this.formView.render();
    this.confirmationView.view.style.display = 'none';
    this.reviewView.view.style.display = 'none';
    this.formView.view.style.display = 'flex';
  },
  renderReviewView: function renderReviewView() {
    this.reviewView.render();
    this.confirmationView.view.style.display = 'none';
    this.formView.view.style.display = 'none';
    this.reviewView.view.style.display = 'flex';
  },
  renderConfirmationView: function renderConfirmationView() {
    this.confirmationView.render();
    this.formView.view.style.display = 'none';
    this.reviewView.view.style.display = 'none';
    this.confirmationView.view.style.display = 'flex';
  },
  render: function render() {
    this.buildFormView();
    this.buildReviewView();
    this.buildConfirmationView();
    this.renderFooter();
    this.renderFormView();
  }
};

exports.default = appointmentView;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.google = google;
exports.ics = ics;
// @param {Object} event
// @param {string} event.title
// @param {ISOString-ish date: yyyymmddThhmmss} event.start
// @param {ISOString-ish date: yyyymmddThhmmss} event.end
// @param {number} event.length in minutes
// @param {string} event.address
// (optional) @param {string} event.description

function google(event, timezone) {
  return encodeURI(['https://www.google.com/calendar/render', '?action=TEMPLATE', '&text=' + (event.title || ''), '&dates=' + (event.start || ''), '/' + (event.end || ''), '&details=' + (event.description || ''), '&location=' + (event.address || ''), '&sprop=&sprop=name:', '&ctz=' + timezone].join(''));
}

function ics(event, timezone) {
  return encodeURI('data:text/calendar;charset=utf8,' + ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'DTSTART;TZID=' + timezone + ':' + (event.start || ''), 'DTEND;TZID=' + timezone + ':' + (event.end || ''), 'SUMMARY:' + (event.title || ''), 'DESCRIPTION:' + (event.description || ''), 'LOCATION:' + (event.address || ''), 'END:VEVENT', 'END:VCALENDAR'].join('\n'));
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _domHelpers = __webpack_require__(1);

var _appointmentView = __webpack_require__(15);

var _appointmentView2 = _interopRequireDefault(_appointmentView);

var _widgetController = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createInputField(id, labelText, attr) {
  var error = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var tag = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'input';

  var inputRow = (0, _domHelpers.createEl)('div', _appointmentView2.default.formInputRow);
  var label = (0, _domHelpers.createEl)('label', _appointmentView2.default.formLabel, labelText, { for: id });
  var input = (0, _domHelpers.createEl)(tag, _appointmentView2.default.formTextInput, '', Object.assign(attr, { id: id }));
  input.addEventListener('invalid', function () {
    input.setCustomValidity(error);
  });
  input.addEventListener('input', function () {
    input.setCustomValidity('');
    if (!input.checkValidity()) {
      input.setCustomValidity(error);
    }
  }, false);
  inputRow.append(label, input);
  return inputRow;
}

var phoneRegex = '^\\(?[2-9]{1}[\\d]{2}\\)?-?[2-9]{1}\\d{2}-?\\d{4}$';
var isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

var extraQuestions = {
  orthoconfirm: '\n    <label class=' + _appointmentView2.default.radioLabel + '>* Are you looking to get braces or invisalign?\n        <select class=' + _appointmentView2.default.dropdown + ' required >\n            <option />\n            <option value="yes">Yes</label>\n            <option value="no">No</label>\n        </select>\n      </label>\n  '
};

var form = {
  init: function init() {
    var formAttributes =  true ? { id: 'openchair_widget-form' } : { id: 'openchair_widget-form', novalidate: true };
    this.form = (0, _domHelpers.createEl)('form', _appointmentView2.default.form, '', formAttributes);

    // create all the inputs
    var patientFirstName = createInputField('openchair-patient-first-name', '* First Name', { type: 'text', inputmode: 'latin-name', required: true, placeholder: 'First Name' }, 'This field is required');
    var patientLastName = createInputField('openchair-patient-last-name', '* Last Name', { type: 'text', inputmode: 'latin-name', required: true, placeholder: 'Last Name' }, 'This field is required');
    var parentName = createInputField('openchair-guardian-name', 'Guardian', { type: 'text', inputmode: 'latin-name', placeholder: 'First Name Last Name' });
    var emailAddress = createInputField('openchair-email', '* Email', { type: 'email', required: true, placeholder: 'email@example.com' }, 'Please input a valid email address');

    var phoneNumber = createInputField('openchair-phone', '* Phone', { type: 'tel', required: true, placeholder: '987-654-3210', pattern: phoneRegex }, 'Please input a valid phone number');
    var message = createInputField('openchair-message', 'Message', { maxlength: 1000, placeholder: 'How can we help you?' }, 'textarea');
    this.form.append(patientFirstName, patientLastName, parentName, emailAddress, phoneNumber, message);

    if (_widgetController.widgetCtrl.cloud9Practice()) {
      var zipCode = createInputField('openchair-zip-code', '* Zip Code', { type: 'number', required: true, pattern: isValidZip, placehold: 'Zip Code' }, 'Please enter a valid zip code');
      this.form.append(zipCode);
    }

    if (_widgetController.widgetCtrl.getExtraFormInfo()) {
      var extraQuestion = (0, _domHelpers.createEl)('div', _appointmentView2.default.formInputRow, '', { id: 'openchair-orthoconfirm' });
      extraQuestion.innerHTML = extraQuestions.orthoconfirm;
      this.form.append(extraQuestion);
    }

    return this.form;
  },
  render: function render() {
    this.form.reset();
  }
};

exports.default = form;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _momentTimezone = __webpack_require__(6);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _domHelpers = __webpack_require__(1);

var _calendar = __webpack_require__(9);

var _widgetController = __webpack_require__(0);

var _appointmentView = __webpack_require__(15);

var _appointmentView2 = _interopRequireDefault(_appointmentView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeAppointment(booking, location) {
  var datetime = _momentTimezone2.default.tz(booking.start_datetime, _widgetController.widgetCtrl.getTz());
  var address = {
    street: location.street_address,
    full: location.city + ', ' + location.state + ' ' + location.zip
  };
  return {
    date: datetime.format('dddd, MMMM D YYYY'),
    time: datetime.format('h:mm A'),
    location: {
      name: location.name,
      address: address
    }
  };
}

var findTimeRange = function findTimeRange(startDateTime) {
  var timeString = _momentTimezone2.default.tz(startDateTime, _widgetController.widgetCtrl.getTz()).format('h:mm A');
  if (timeString === '9:30 AM') {
    return '9:30 AM – 12:00 PM';
  }
  if (timeString === '12:00 PM') {
    return '12:00 PM – 2:30 PM';
  }
  if (timeString === '2:30 PM') {
    return '2:30 PM – Closing';
  }
  return timeString + ' \u2013 9:30 PM';
};

var infoTables = {
  booking: {
    render: function render() {
      var appointment = makeAppointment(_widgetController.widgetCtrl.getAppointmentInfo(), _widgetController.widgetCtrl.getCurrentLocation());
      var bookingInfoFragment = document.createDocumentFragment();

      this.locationElem = (0, _domHelpers.createEl)('div', _appointmentView2.default.bookingValue);
      this.dateElem = this.locationElem.cloneNode();
      this.timeElem = this.locationElem.cloneNode();
      this.timeRangeElem = this.locationElem.cloneNode();

      var labelRow = (0, _domHelpers.createEl)('div', _appointmentView2.default.appointmentDetails, 'Appointment Details:');
      var locationRow = (0, _domHelpers.createEl)('div', _appointmentView2.default.bookingRow);
      this.locationElem.append((0, _domHelpers.createEl)('span', _appointmentView2.default.bookingValueLine, appointment.location.name), (0, _domHelpers.createEl)('span', _appointmentView2.default.bookingValueLine, appointment.location.address.street), (0, _domHelpers.createEl)('span', _appointmentView2.default.bookingValueLine, appointment.location.address.full));
      locationRow.append((0, _domHelpers.createEl)('div', _appointmentView2.default.bookingLabel, 'location'), this.locationElem);
      var dateRow = (0, _domHelpers.createEl)('div', _appointmentView2.default.bookingRow);
      this.dateElem.append((0, _domHelpers.createEl)('span', _appointmentView2.default.bookingValueLine, appointment.date));
      dateRow.append((0, _domHelpers.createEl)('div', _appointmentView2.default.bookingLabel, 'date'), this.dateElem);
      var booking = _widgetController.widgetCtrl.getAppointmentInfo();
      var timeText = (0, _calendar.findTimeText)(booking.automation, booking.start_datetime);

      this.timeElem.append((0, _domHelpers.createEl)('span', _appointmentView2.default.bookingValueLine, timeText));
      var timeRow = (0, _domHelpers.createEl)('div', _appointmentView2.default.bookingRow);
      timeRow.append((0, _domHelpers.createEl)('div', _appointmentView2.default.bookingLabel, 'time'), this.timeElem);

      var message = void 0;
      var timeRangeRow = void 0;
      if (booking.automation) {
        message = (0, _domHelpers.createEl)('div', 'openchair-message-section');
        var autoMessage = (0, _domHelpers.createEl)('p', _appointmentView2.default.automationMessage, 'Please fill out your contact information. We will use this to send you a confirmation email with an appointment time within your selected range.');
        message.append((0, _domHelpers.createEl)('h2', _appointmentView2.default.automationH2, 'Thank you for selecting an appointment window at ' + appointment.location.name + '.'), autoMessage);

        this.timeRangeElem.append((0, _domHelpers.createEl)('span', _appointmentView2.default.bookingValueLine, findTimeRange(booking.start_datetime)));
        timeRangeRow = (0, _domHelpers.createEl)('div', _appointmentView2.default.bookingRow);
        timeRangeRow.append((0, _domHelpers.createEl)('div', _appointmentView2.default.bookingLabel, 'time range'), this.timeRangeElem);
      } else {
        message = '';
        timeRangeRow = '';
      }

      bookingInfoFragment.append(message, labelRow, locationRow, dateRow, timeRow, timeRangeRow);
      return bookingInfoFragment;
    }
  },
  patient: {
    render: function render() {
      var patient = _widgetController.widgetCtrl.getPatientInfo();
      var fragment = document.createDocumentFragment();
      Object.keys(patient).forEach(function (key) {
        var row = (0, _domHelpers.createEl)('div', _appointmentView2.default.patientRow);
        if (key === 'message') {
          row.append((0, _domHelpers.createEl)('div', _appointmentView2.default.patientLabel, key), (0, _domHelpers.createEl)('div', _appointmentView2.default.patientValueMessage, patient[key]));
        } else {
          row.append((0, _domHelpers.createEl)('div', _appointmentView2.default.patientLabel, key), (0, _domHelpers.createEl)('div', _appointmentView2.default.patientValue, patient[key]));
        }
        fragment.append(row);
      });

      return fragment;
    }
  }
};

exports.default = infoTables;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNyIgaGVpZ2h0PSIzNyIgdmlld0JveD0iMCAwIDU0LjQgNTQuNCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5hIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+cmc8L3RpdGxlPgogIDxwYXRoIGNsYXNzPSJhIiBkPSJNMjksMUEyNy4yLDI3LjIsMCwxLDAsNTYuMiwyOC4yaDBBMjcuMiwyNy4yLDAsMCwwLDI5LDFabTAuMiwyMC43YTIuOCwyLjgsMCwwLDEsMi4zLTFjMS44LDAuMiwxLjUsMS42LDEuNiwyLjJhMi40LDIuNCwwLDAsMC0xLjctMS4zQzMwLjUsMjEuNSwyOS41LDIxLjMsMjkuMiwyMS43Wm05LjIsMTUuOWE0Mi4xLDQyLjEsMCwwLDEtMi41LTUuOCwyLjksMi45LDAsMCwwLDIuNC0uMSwxMi45LDEyLjksMCwwLDEsMCwzLjRBNyw3LDAsMCwwLDM4LjQsMzcuNlptMy40LDEyLjZBNjcuNCw2Ny40LDAsMCwwLDQwLDQxLjksMjQuNywyNC43LDAsMCwwLDM5LDM5YTIuNCwyLjQsMCwwLDAsMS43LDEuMmMyLjEsMC41LDIuNi0yLjEuNC00LjVhNy41LDcuNSwwLDAsMS0xLjktNC40LDguNiw4LjYsMCwwLDAsMi0xLjljLTEwLDIuOC05LjUtMy43LTkuNS0zLjcsMC4xLDMuMSw0LjgsMyw0LjgsM2gwYzEuMS0xLjMsMy43LTIuMSw4LjctMS41LDAsMC0xLjctNS4yLTcuMi01LjctMy4zLS4zLTQsMi4yLTQsMi4ycy0wLjQtMi44LDMuOC0zLDItNC0uNS01LjgtMS4yLTIuMi0yLjMtMi4xLDAuNiwxLjIsMCwxLjMtNS43LTcuMi03LjMtNy45LTAuNi44LDAsMS4xLDMuNSw0LjIsMi41LDQuNi0yLjUuOS00LjgtMS45LTMuOS00LjEtNi4yLTQuMi0xLjEuOSwwLjcsMiwyLjMsMS43LDIuMywyLjdhMi4yLDIuMiwwLDAsMCwxLjksMnMtMSwuNy0zLjItMC45LTMuMi0yLjgtNC44LTMuMS0zLjQsNiwuNiw4LjNjMi4zLDEuNCwzLjMsMS43LDMuNywxLjdhNS42LDUuNiwwLDAsMS0yLjQuMXMwLjksMS42LDQuMy43LDYsMC4xLDUuMSwxLjJBMzMuNCwzMy40LDAsMCwwLDIwLjcsMzJjLTEuOSw1LjYtMi4yLDExLTUuNywxMy45YTIwLjEsMjAuMSwwLDAsMS0xLjQsMi41QTI1LjUsMjUuNSwwLDEsMSw1NC43LDI4LjIsMjYsMjYsMCwwLDEsNDEuOCw1MC4yWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuOCAtMSkiLz4KPC9zdmc+Cg=="

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// openchair.js